import {
    AfterViewInit,
    AfterViewChecked,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    SimpleChanges,
    ViewChildren
} from '@angular/core';
import {ProductModel, QuoteOrderSampleModel, RequestParamModel} from '../../models';
import {Constants} from '../../constants';
import {TransferProductModalComponent} from '../../../stock-allocation/modal/transfer-product-modal/transfer-product-modal.component';
import {snapUpToMoi, formatMoiQty} from 'src/app/shared/utils/snap-to-moi';
import {AlertService, DebugLoggerService, HelperService, SubscribersService} from '../../services';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmModalComponent} from '../confirm-modal/confirm-modal.component';
import {ProductsService, QuoteOrderSampleService, NotificationService} from '@coreapiservices';
import Quill from 'quill';
import {debounceTime, firstValueFrom, forkJoin, Subject, Subscription, tap} from 'rxjs';
import {
    toggleTotalPremiumAndAdhesiveCalculator,
    calculateConsumableSummary
} from '../../utils/premium-and-adhesive-calculator'
import {DndDropEvent} from 'ngx-drag-drop';
import {QuoteService} from '../../apiservices/quote.service';
import {
    UpdateStockRequiredDateModalComponent
} from 'src/app/shared/modal/update-stock-required-date-modal/update-stock-required-date-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
    UpdateSiteContactDetailModalComponent
} from 'src/app/shared/modal/update-site-contact-detail-modal/update-site-contact-detail-modal.component';
import {ChooseCarrierModalComponent} from 'src/app/orders/modal/choose-carrier-modal/choose-carrier-modal.component';
import {RevertSplitModalComponent} from 'src/app/orders/modal/revert-split-modal/revert-split-modal.component';
import {
    StatusChangeConfirmationComponent
} from '../../../quote-order-sample-core/status-change-confirmation/status-change-confirmation.component';
import {MilestoneStatusService} from '../../apiservices/milestone-status.service';
import {StockAllocationService} from '../../apiservices/stock-allocation.service';
import {
    MailTemplateEditOnStatusChangeComponent
} from 'src/app/quote-order-sample-core/mail-template-edit-on-status-change/mail-template-edit-on-status-change.component';
import moment from 'moment';
import {DatePipe} from '@angular/common';
import {HttpErrorResponse} from "@angular/common/http";
import {WebSocketService} from '../../services/helpers/websocket.service';
import {isConsumableQuantityAtMinimum} from '../../utils/consumable-quantity.util';

@Component({
  standalone: false,
    selector: 'app-product-detail-section',
    // Eager: Angular 22 defaults every component to OnPush, which would leave this view
    // unpainted after its subscribe callbacks (see app.component.ts for the full note).
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './product-detail-section.component.html',
    styleUrl: './product-detail-section.component.css',
    providers: [DatePipe]
})
export class ProductDetailSectionComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit, AfterViewChecked {

    @Input() modelOrder: any;
    @Input() productAccessories: any;
    @Input() isQuoteCancel: any;
    @Input() isQuoteUnconverted: any;
    @Input() isOfflineOrder: boolean = false;
    // SQ (offline pending) quotes are rendered on the quote screen but must show the consumable
    // calculators exactly like an SO offline order (RRP / trade / discount / discounted price).
    @Input() isOfflineQuote: boolean = false;
    @Input() isOrderCancel: any;
    @Input() users: any;
    @Input() selectedUsers: any;
    @Input() removedUsers: any;
    @Input() productDetail: any;
    @Input() loginUserId: any;
    @Input() s3BucketImageURL: any
    @Input() isQuoteAccepted: boolean = false
    @Input() isStatusChangeToOTT: boolean = false
    @Input() isPreview: any
    @Input() isQuoteDetail: boolean = false
    @Input() isOrderDetail: boolean = false
    @Input() isDespatchDetail: boolean = false
    @Input() isShowTitle: boolean = false
    @Input() updateQuillEditorsTrigger: number = 0; // ✅ Trigger to update Quill editors from parent
    @Input() isStickyHeader: boolean = false; // ✅ Enable/disable sticky table header
    @Input() pendingTasks: any[] = []; // ✅ All pending tasks for the order
    @Output("itemSidebarEvent") itemSidebarEvent: EventEmitter<any> = new EventEmitter();
    @Output("getOrderEvent") getOrderEvent: EventEmitter<any> = new EventEmitter();
    @Output() ChangeStatusEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output("containerSidebarClickEvent") containerSidebarClickEvent: EventEmitter<any> = new EventEmitter();
    @Output("selectedContainerEvent") selectedContainerEvent: EventEmitter<any> = new EventEmitter();
    @Output("selectedProductAddContainerEvent") selectedProductAddContainerEvent: EventEmitter<any> = new EventEmitter();
    @Output("taskCompletionEvent") taskCompletionEvent: EventEmitter<any> = new EventEmitter(); // ✅ Event for task completion
    @ViewChildren('editorContainer') editorContainers: QueryList<ElementRef>;
    is_open_addItem_sidebar: boolean = false
    productModel: any = [];
    @Input() isShowAdhesivePremiumSealer: boolean = false
    getGoodDispatchSeriesStatus = Constants.GOODS_DISPATCHED_MILESTONE_STATUS_ARRAY;
    noImage = Constants.NO_IMAGE_PRODUCT;

    @Output() isLoadingEvent = new EventEmitter<boolean>();

    consumableSummary: any = []
    modalRef?: BsModalRef;
    isManualShippingRateChange: boolean = false;
    isLoading: boolean = false;
    /** Track concurrent loading operations to prevent race conditions */
    private loadingOperations = new Set<string>();
    /** Track Unleashed sync state to disable UI during sync */
    isSyncingWithUnleashed = false;
    constants = Constants;
    quillEditorContainers: any = [];
    isQuillEditorInitialized: boolean = false;
    message: string = '';
    keyupTimeout: any;
    private commentUpdateSubject = new Subject<{
        comment: string;
        id: number;
        oldNote: string;
    }>();
    quoteProductExistingNotifications: any = []
    unReadNotificationCount = 0;
    containsComment: boolean = false;
    isDisabledQuoteDetail: any = false;
    isAddRemoveProduct: boolean = false;
    draggedProductIndex = null;
    hoveredProductIndex = null;
    timer: any;
    private debounceTimers: { [key: number]: any } = {};
    s3BucketProfileURL!: any;
    disableStatusIds = new Set([Constants.ORDER_DELIVERY_UNCONFIRMED_ID, Constants.ORDER_DELIVERY_OUT_TO_TENDER_ID, Constants.ORDER_DELIVERY_CONFIRMED_ID, Constants.ORDER_DELIVERY_CLIENT_ORGANIZED_ID, Constants.ORDER_DELIVERY_DISPATCHED_ID, Constants.ORDER_DELIVERD_ID, Constants.ORDER_AWAITING_FEEDBACK_ID, Constants.ORDER_COMPLETED_ID, Constants.ORDER_ORDER_CANCELLED_ID, Constants.ORDER_ARCHIVED_ID]);
    disableDragAndDropBasedOnOrder: boolean = false;

    // Price update warning state management
    dismissedPriceWarnings: Set<number> = new Set();

    /* ############ Assembled Products (PDF section 4.1) ############
     * An assembled product owns no stock of its own, so instead of its own stock cards we show a
     * roll-up summary plus the SAME familiar card layout once per COMPONENT SKU.
     * Keyed by product id; loaded lazily when the stock row is expanded.
     */
    assembledInfoByProduct: { [productId: number]: any } = {};
    assembledLoadingByProduct: { [productId: number]: boolean } = {};
    /** The figures the product's Stock On Hand card shows, for the SKU hover. Loaded with the above. */
    assembledShelfByProduct: { [productId: number]: any } = {};
    /** Assembled products named by live stock events, re-read together once the events settle. */
    private assembledRefreshIds = new Set<number>();
    private assembledStockSub: Subscription | null = null;

    /**
     * What one order line needs of a single component, and whether free stock covers it.
     *
     * These are component methods rather than `@let` declarations in the template on purpose: a
     * `@let` inside the components `@for` changes the generated template-context nesting, and the
     * surrounding block reads `assembledInfoByProduct` from an outer context — which then resolved
     * one level off and came back undefined, crashing the whole product table. Plain methods keep
     * the block's context depth exactly as it was.
     */
    assembledComponentNeeded(component: any, productsRow: any): number {
        return (Number(component?.required_per_unit) || 0) * (Number(productsRow?.quantity) || 0);
    }

    assembledComponentShortfall(component: any, productsRow: any): number {
        return this.assembledComponentNeeded(component, productsRow) - (Number(component?.free_qty) || 0);
    }

    /**
     * Hangs the breakdown on the order row itself, as product.assembledInfo.
     *
     * WHY NOT read assembledInfoByProduct[...] straight from the template: these rows render several
     * templates deep (nested conditionals inside the products @for). Reading a COMPONENT property
     * from that depth resolved against the wrong template context and came back undefined, throwing
     * "Cannot read properties of undefined" on every change-detection pass — which leaves the panel
     * stuck on its loader. Stamping onto the row means the template only ever walks the loop
     * variable it already holds, at any depth.
     */
    private stampAssembledInfo(targets: any[], info: any, shelf: any = null) {
        (targets || []).forEach((target: any) => {
            if (target?.product) {
                target.product.assembledInfo = info ?? null;
                target.product.assembledShelf = shelf ?? null;
            }
        });
    }

    /**
     * The SKU hover on an assembled line shows the same Total / Allocated / Available as the product's
     * Stock On Hand card — Unleashed's Can Assemble, not the finished SKU's own (always empty) stock.
     * Loaded on the first hover, with the breakdown the stock row uses.
     */
    onWarehousePopoverShown(productsRow: any) {
        if (productsRow?.product?.is_assembled_product && productsRow?.product_id) {
            this.loadAssembledInfo(productsRow.product_id, [productsRow]);
        }
    }

    /** The card figures out of a PHP onHandStock response, for the SKU hover. */
    private shelfFiguresOf(onHandStock: any): any {
        if (!onHandStock) {
            return null;
        }
        return {
            total_qty: Number(onHandStock.total_qty) || 0,
            allocated_qty: Number(onHandStock.allocated_qty) || 0,
            available_qty: Number(onHandStock.available_qty) || 0,
            short_by: Number(onHandStock.short_by) || 0,
            unleashed: onHandStock.unleashed ?? null,
            // Unleashed's own Can Assemble — shown for reference only.
            can_assemble: onHandStock.unleashed?.can_assemble ?? null,
        };
    }

    /* ############ Per-component allocation — PDF §4.1 and §4.2 ############
     *
     * An assembled line is demand for several DIFFERENT products, so it cannot be allocated through
     * the single source slot an ordinary line uses. It expands instead to one child row per
     * component, each with its own allocation control, and the parent's position, status and ETA are
     * recalculated server-side from all the components together (§4.1: the parent "is never edited
     * directly").
     *
     * All state hangs off the order row itself (productsRow.componentAllocation). These templates
     * render several levels deep, and reading a component-level property from that depth resolves
     * against the wrong template context and comes back undefined — which is what previously threw on
     * every change-detection pass and left the panel spinning.
     *
     * Kept deliberately in step with StockAllocationComponent, which renders the same panel for the
     * two Stock Allocation tabs. If you change the shape here, change it there.
     */

    /**
     * Opens one component's panel, closing whichever was open. Nothing is fetched: the child rows
     * already carry each component's allocation and ETA, and the panel's only content — the §4.2
     * ledger — is loaded on demand by toggleLedger().
     */
    openComponentBoard(productsRow: any, componentProductId: any) {
        const state = productsRow?.componentAllocation;
        if (!state) {
            return;
        }
        state.openComponentId = (state.openComponentId === componentProductId) ? null : componentProductId;
        /*
         * Built ONCE, here, and stored — never as an object literal in the template. The card set
         * reloads its board in ngOnChanges, and a literal would be a fresh object on every change
         * detection pass, so it would refetch forever.
         */
        state.boardInput = state.openComponentId
            ? {quoteProductId: productsRow?.id, componentProductId: state.openComponentId}
            : null;
        this.changeDetection.detectChanges();
    }

    isComponentBoardOpen(productsRow: any, componentProductId: any): boolean {
        return productsRow?.componentAllocation?.openComponentId === componentProductId;
    }

    private frozenContainersSource: any[] | null = null;
    private frozenContainersByIdCache: Record<number, any> = {};

    /**
     * Container id -> that container as the order API sent it on a CLOSED line of this order (its
     * order archived, or the line at the warehouse), i.e. carrying the APCD / ETA the line was
     * frozen with. Every line's stock panel lists all of the product's containers, so each panel
     * needs the order's copy, not only its own line's — see StockAllocationContentComponent.withLineDates.
     *
     * Lines on one PO are frozen by the same write, so they agree; the first one wins otherwise.
     * Rebuilt only when the order's line array is replaced: a fresh object on every change
     * detection pass would be a new input each time.
     */
    get frozenOrderContainers(): Record<number, any> {
        const lines = this.modelOrder?.quote_product;
        if (lines !== this.frozenContainersSource) {
            this.frozenContainersSource = lines ?? null;
            const byId: Record<number, any> = {};
            for (const line of Array.isArray(lines) ? lines : []) {
                const id = Number(line?.container_id);
                if (!id || Number(line?.frozen_dates_container_id) !== id || !line?.container || byId[id]) continue;
                byId[id] = line.container;
            }
            this.frozenContainersByIdCache = byId;
        }
        return this.frozenContainersByIdCache;
    }

    /** The component whose child row is open, so the ledger can render below the table. */
    openComponent(productsRow: any): any {
        const openId = productsRow?.componentAllocation?.openComponentId;
        if (!openId) {
            return null;
        }
        return (productsRow?.componentAllocation?.detail?.components || [])
            .find((c: any) => c.component_product_id === openId) ?? null;
    }

    /**
     * One call: each component of this line, what the line needs of it, what is held, its own ETA and
     * every source it could be moved to — plus the parent roll-up (§4.1).
     */
    loadComponentBoards(productsRow: any) {
        const quoteProductId = productsRow?.id;
        if (!quoteProductId) {
            return;
        }

        const previous = productsRow.componentAllocation;
        productsRow.componentAllocation = {
            open: true,
            loading: true,
            error: null,
            detail: previous?.detail ?? null,
            summary: previous?.summary ?? null,
            openComponentId: previous?.openComponentId ?? null,
            /*
             * MUST be carried over. The card set is put into component mode by this very
             * object; dropping it on a refresh silently returns that component to ORDINARY
             * mode, and the next drag then tries to PATCH a quote_product id the row has not
             * got (component rows are allocation slices, not order lines).
             */
            boardInput: previous?.boardInput ?? null,
            // Same reason as boardInput: this object is what puts the card set into
            // assembled-UNIT mode. Dropping it on a refresh knocks the panel out of that
            // mode mid-flight, and it disappears from under whoever is using it.
            //
            // Built ONCE and stored — never an object literal in the template, which would be a
            // fresh object every change detection pass and refetch forever. The cards belong to
            // the LINE (assembled units) and need nothing from the rows below, so they are given
            // it now: the card set opens straight away on its own skeleton, as an ordinary
            // product's does, and loads alongside the rows instead of after them.
            unitBoardInput: previous?.unitBoardInput?.quoteProductId === quoteProductId
                ? previous.unitBoardInput
                : {quoteProductId},
            ledgers: previous?.ledgers ?? {}
        };
        this.changeDetection.detectChanges();

        this.stockAllocationService.getComponentAllocationRows(quoteProductId).subscribe({
            next: (detail: any) => {
                const state = productsRow.componentAllocation;
                state.loading = false;
                state.detail = detail;
                state.summary = detail?.summary ?? null;
                if (detail?.is_blocked) {
                    state.error = detail.blocked_reason;
                }
                this.applyParentLine(productsRow, detail?.parent_line);
                this.changeDetection.detectChanges();
            },
            error: (err: any) => {
                productsRow.componentAllocation.loading = false;
                productsRow.componentAllocation.error =
                    err?.error?.message || 'Could not load the component allocation.';
                this.changeDetection.detectChanges();
            }
        });
    }

    /**
     * The value the child row's Allocation control holds for one source — the same shape PHP puts in
     * `current_source`, so the selected option matches without a second lookup.
     */
    sourceKey(source: any): string {
        return source?.source_type === 'CONTAINER'
            ? `CONTAINER:${source?.container_id}`
            : (source?.source_type || 'TBC');
    }

    /**
     * §4.1: "Reallocating a component (e.g. moving PROD_EDG_VERDA to a different container)
     * automatically updates the parent's ETA — no separate step for the assembled product."
     *
     * Posts to `allocate`, which replaces only this component's rows — `save` replaces the whole line
     * and would wipe the siblings. The rows are re-read afterwards rather than patched locally,
     * because the parent roll-up is derived server-side.
     */
    reallocateComponent(productsRow: any, component: any, value: string) {
        const quoteProductId = productsRow?.id;
        const componentProductId = component?.component_product_id;
        if (!quoteProductId || !componentProductId || !value) {
            return;
        }

        const isContainer = value.startsWith('CONTAINER:');
        const payload = {
            component_product_id: componentProductId,
            source_type: isContainer ? 'CONTAINER' : value,
            container_id: isContainer ? Number(value.split(':')[1]) : null
        };

        // Optimistic on the control alone, so the select does not snap back while saving.
        component.current_source = value;
        this.changeDetection.detectChanges();

        this.stockAllocationService.allocateComponent(quoteProductId, payload).subscribe({
            next: () => {
                this.onComponentAllocationChanged(productsRow);
                const ledger = productsRow?.componentAllocation?.ledgers?.[componentProductId];
                if (ledger?.open) {
                    this.loadLedger(productsRow, componentProductId);
                }
            },
            error: (err: any) => {
                this.alertService.error(err?.error?.message || 'Could not reallocate that component.');
                this.loadComponentBoards(productsRow);
            }
        });
    }

    /* ---- §4.2 per-SKU ledger ----
     *
     * "On each SKU: the ledger view — every order's slice with its source, quantity and ETA, in
     *  allocation order", plus what each source holds and has left. The first-come-first-served
     * suggestion is a separate, explicit step: the platform computes what it WOULD give and the team
     * confirm it. Nothing is written until Confirm.
     */

    toggleLedger(productsRow: any, componentProductId: any) {
        const state = productsRow?.componentAllocation;
        if (!state || !componentProductId) {
            return;
        }
        state.ledgers = state.ledgers || {};

        if (state.ledgers[componentProductId]?.open) {
            state.ledgers[componentProductId].open = false;
            this.changeDetection.detectChanges();
            return;
        }

        this.loadLedger(productsRow, componentProductId);
    }

    /** Separate from toggleLedger so a write that invalidates an OPEN ledger can refresh it in place. */
    loadLedger(productsRow: any, componentProductId: any) {
        const state = productsRow?.componentAllocation;
        if (!state || !componentProductId) {
            return;
        }
        state.ledgers = state.ledgers || {};
        state.ledgers[componentProductId] = { open: true, loading: true, data: null, suggestion: null, error: null };
        this.changeDetection.detectChanges();

        this.stockAllocationService.getSkuLedger(componentProductId).subscribe({
            next: (data: any) => {
                state.ledgers[componentProductId] = { open: true, loading: false, data, suggestion: null, error: null };
                this.changeDetection.detectChanges();
            },
            error: (err: any) => {
                state.ledgers[componentProductId] = {
                    open: true, loading: false, data: null, suggestion: null,
                    error: err?.error?.message || 'Could not load the ledger.'
                };
                this.changeDetection.detectChanges();
            }
        });
    }

    ledgerFor(productsRow: any, componentProductId: any): any {
        return productsRow?.componentAllocation?.ledgers?.[componentProductId] ?? null;
    }

    /** Asks what first-come, first-served would give. Read-only — nothing is written. */
    suggestLedger(productsRow: any, componentProductId: any) {
        const ledger = this.ledgerFor(productsRow, componentProductId);
        if (!ledger || ledger.loading) {
            return;
        }
        ledger.loading = true;
        this.changeDetection.detectChanges();

        this.stockAllocationService.suggestSkuLedger(componentProductId).subscribe({
            next: (suggestion: any) => {
                ledger.loading = false;
                ledger.suggestion = suggestion;
                this.changeDetection.detectChanges();
            },
            error: (err: any) => {
                ledger.loading = false;
                ledger.error = err?.error?.message || 'Could not work out the suggestion.';
                this.changeDetection.detectChanges();
            }
        });
    }

    dismissSuggestion(productsRow: any, componentProductId: any) {
        const ledger = this.ledgerFor(productsRow, componentProductId);
        if (ledger) {
            ledger.suggestion = null;
            this.changeDetection.detectChanges();
        }
    }

    /**
     * Confirms the suggestion. Writes across EVERY order in the sequence — an earlier order may need
     * stock a later one is holding — so this line's rows and figures are re-read afterwards.
     */
    applyLedger(productsRow: any, componentProductId: any) {
        const ledger = this.ledgerFor(productsRow, componentProductId);
        if (!ledger || ledger.loading) {
            return;
        }
        ledger.loading = true;
        this.changeDetection.detectChanges();

        this.stockAllocationService.applySkuLedger(componentProductId).subscribe({
            next: (result: any) => {
                ledger.loading = false;
                ledger.suggestion = null;
                ledger.data = result?.ledger ?? ledger.data;
                this.alertService.success(
                    `Ledger confirmed - ${result?.applied ?? 0} allocation(s) across ${result?.lines ?? 0} order line(s).`
                );
                this.onComponentAllocationChanged(productsRow);
            },
            error: (err: any) => {
                ledger.loading = false;
                ledger.error = err?.error?.message || 'Could not confirm the ledger.';
                this.changeDetection.detectChanges();
            }
        });
    }

    /**
     * A component was moved: the sibling rows, the parent roll-up and the product's own buildable
     * figure can all shift, and the order's totals are read from the parent line.
     */
    onComponentAllocationChanged(productsRow: any, event?: any) {
        /*
         * A structural change — a split added a line, a merge removed one — has to reach the order
         * itself, or the new line simply is not in the Product Detail table until the page is
         * reloaded by hand. The panel survives the re-fetch because restoreToggleStates() now
         * re-hydrates any assembled row that is still expanded.
         */
        if (event?.structural) {
            this.getOrderEvent.emit(true);
            return;
        }

        this.assembledInfoByProduct[productsRow?.product_id] = undefined as any;
        this.loadAssembledInfo(productsRow?.product_id, [productsRow]);
        // Refreshes the panel AND, via applyParentLine, the order row's own status cell.
        //
        // Deliberately NOT getOrderEvent.emit(true): re-fetching the order replaces every
        // quote_product object, which drops isStockExpanded and the componentAllocation state
        // hanging off the row — the panel the admin is working in shuts underneath them, and
        // the next click reads as a no-op because it is closing an already-empty row. Allocation
        // changes no price or total, so the only stale cell is the line's own position, and
        // `parent_line` in the rows payload carries exactly that.
        this.loadComponentBoards(productsRow);
    }

    /**
     * Copies the parent line's live position onto the order row, so the status cell agrees with the
     * allocation without a full order re-fetch. Same field names the order-detail response uses.
     */
    private applyParentLine(productsRow: any, parentLine: any) {
        if (!productsRow || !parentLine) {
            return;
        }
        productsRow.stock_available = parentLine.stock_available;
        productsRow.container_id = parentLine.container_id;
        productsRow.container = parentLine.container;
        /*
         * The line's own status too: the status cell shows it ahead of the position, so a line moved
         * back to Unassigned kept reading as its old container's status until the page was reloaded.
         * Only when the API sends it, so an older response cannot blank the cell.
         */
        if ('status_quote_product' in parentLine) {
            productsRow.status_id = parentLine.status_id;
            productsRow.status_quote_product = parentLine.status_quote_product;
        }
    }

    /**
     * Splits an assembled ORDER LINE into parent + child — the same thing the Split Stock option
     * does for an ordinary product, and it means the same thing here: deliver part of the order
     * now and part later. It is NOT the same as splitting a component across sources, which is
     * done by dragging on the component's cards and creates no new order line.
     *
     * The split itself is the ordinary endpoint. What is extra is the call after it: the Node API
     * that performs the split does not know component allocations exist, so without rebalancing the
     * parent would keep every slice it held while its quantity has dropped. Rebalancing releases the
     * excess to Unassigned on both lines, where the team places it deliberately.
     */
    async splitAssembledLine(productsRow: any) {
        const quoteProductId = productsRow?.id;
        if (!quoteProductId || !productsRow?.quantity) {
            return;
        }

        const instance = this.modalService1.open(TransferProductModalComponent);
        instance.componentInstance.showSplitStockOption = true;
        instance.componentInstance.disableSplitStock =
            !!this.modelOrder?.order_number?.startsWith(Constants.SALES_ORDER_NUMBER_PREFIX);
        instance.componentInstance.size = productsRow.quantity;
        instance.componentInstance.uom = productsRow?.product?.unit_of_measurement?.name;
        instance.componentInstance.product = productsRow.product;

        let result: any;
        try {
            result = await instance.result;
        } catch (e) {
            return;   // dismissed
        }
        if (!result) {
            return;
        }

        const splitQuantity = +result.splitStock || +result.quantity;
        if (!splitQuantity || splitQuantity >= +productsRow.quantity) {
            this.alertService.error('Enter a quantity smaller than the line quantity to split it.');
            return;
        }

        this.quoteService.splitProductLine({
            parent_id: quoteProductId,
            split_quantity: splitQuantity,
            stock_available: false,
            container_id: null,
        }).subscribe({
            next: () => {
                /*
                 * Sequential, not atomic: the split is committed by the time this runs. If it fails
                 * the parent is left over-allocated, which the panel SHOWS (its components read more
                 * held than needed) rather than hiding — so it is recoverable by hand, not silent.
                 */
                this.stockAllocationService.rebalanceComponentAllocations(quoteProductId).subscribe({
                    next: () => {
                        this.alertService.success('Line split - released stock is on the Unassigned card.');
                        this.getOrderEvent.emit(true);
                    },
                    error: () => {
                        this.alertService.error('Line split, but its component allocations could not be trimmed. Check the components before allocating.');
                        this.getOrderEvent.emit(true);
                    }
                });
            },
            error: (err: any) => {
                this.alertService.error(err?.error?.message || 'Could not split that line.');
            }
        });
    }

    loadAssembledInfo(productId: any, targets: any[] = []) {
        if (!productId) {
            return;
        }
        // Already known: stamp the waiting rows and stop.
        if (this.assembledInfoByProduct[productId] !== undefined) {
            this.stampAssembledInfo(targets, this.assembledInfoByProduct[productId], this.assembledShelfByProduct[productId]);
            return;
        }
        if (this.assembledLoadingByProduct[productId]) {
            return;
        }
        this.assembledLoadingByProduct[productId] = true;

        const requestParamModel = new RequestParamModel();
        // NOTE: `expand` (singular), not `expands`. product/{id} is served by the PHP/Yii API,
        // which reads `expand`; `expands` is the Node API's convention and PHP silently ignores it
        // (returning the product with no onHandStock, hence no assembled breakdown).
        requestParamModel.expand = ['onHandStock'];
        this.productService.getProductDetails(productId, requestParamModel).subscribe({
            next: (product: any) => {
                this.assembledInfoByProduct[productId] = product?.onHandStock?.assembled || null;
                this.assembledShelfByProduct[productId] = this.shelfFiguresOf(product?.onHandStock);
                this.assembledLoadingByProduct[productId] = false;
                this.stampAssembledInfo(targets, this.assembledInfoByProduct[productId], this.assembledShelfByProduct[productId]);
                // Components default to OnPush in this console, so refresh explicitly.
                this.changeDetection.detectChanges();
            },
            error: () => {
                this.assembledInfoByProduct[productId] = null;
                this.assembledShelfByProduct[productId] = null;
                this.assembledLoadingByProduct[productId] = false;
                this.stampAssembledInfo(targets, null);
                this.changeDetection.detectChanges();
            }
        });
    }

    /**
     * An order holding parts of these assembled products reached, changed in or was cancelled against
     * Unleashed, so their figures may have moved. Re-reads only the products this page has already
     * loaded (hover or stock row); the rest load fresh on first use anyway.
     */
    private refreshAssembledInfo() {
        const ids = [...this.assembledRefreshIds];
        this.assembledRefreshIds.clear();
        const rows: any[] = this.modelOrder?.quote_product ?? [];
        ids.forEach((productId) => {
            if (this.assembledInfoByProduct[productId] === undefined || this.assembledLoadingByProduct[productId]) {
                return;
            }
            this.assembledInfoByProduct[productId] = undefined as any;
            this.loadAssembledInfo(productId, rows.filter((row: any) => Number(row?.product_id) === productId));
        });
    }

    constructor(
        private alertService: AlertService,
        private modalService: BsModalService,
        public changeDetection: ChangeDetectorRef,
        private orderService: QuoteOrderSampleService,
        private productService: ProductsService,
        private notificationService: NotificationService,
        private subscribersService: SubscribersService,
        public helperFunction: HelperService,
        private quoteService: QuoteService,
        private modalService1: NgbModal,
        private statusService: MilestoneStatusService,
        private datePipe: DatePipe,
        private webSocketService: WebSocketService,
        private debugLogger: DebugLoggerService,
        private stockAllocationService: StockAllocationService
    ) {
        this.commentUpdateSubject
            .pipe(debounceTime(1000))
            .subscribe(({comment, id, oldNote}) => {
                this.addUpdateQuoteProductComment(comment, id, oldNote);
            });
    }

    ngOnInit() {
        if (this.modelOrder && !this.modelOrder?.is_split_production) {
            this.disableDragAndDropBasedOnOrder = this.modelOrder?.quote_order_status_history?.some(item => this.disableStatusIds.has(item.quote_order_status_id));
        }
        this.debugLogger.log("this.disableDragAndDropBasedOnOrder", this.disableDragAndDropBasedOnOrder);

        this.s3BucketProfileURL =
            Constants.S3_PRODUCT_RESOURCE_IMAGE_KIT_URL + '/USER_PROFILE_PICTURE';

        this.hasProductWithComment();

        this.webSocketService.joinRoom('assembled_stock');
        this.assembledStockSub = this.webSocketService.getAssembledStockEvents()
            .pipe(
                tap((event) => (event?.product_ids ?? []).forEach((id) => this.assembledRefreshIds.add(Number(id)))),
                debounceTime(1500)
            )
            .subscribe(() => this.refreshAssembledInfo());

        /*if (this.modelOrder?.quote_product && Array.isArray(this.modelOrder.quote_product)) {
          this.debugLogger.log('ngOnInit - Before sorting:', this.modelOrder.quote_product.map(p => ({ id: p.id, order_index: p.order_index })));
          this.modelOrder.quote_product = this.sortQuoteProducts([...this.modelOrder.quote_product]);
          this.debugLogger.log('ngOnInit - After sorting:', this.modelOrder.quote_product.map(p => ({ id: p.id, order_index: p.order_index, displayIndex: p.displayIndex })));
          this.changeDetection.detectChanges();
        }*/
    }

    ngOnDestroy() {
        this.assembledStockSub?.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes['modelOrder'] && changes['modelOrder'].currentValue) {
            /*
             * A re-fetched order brings brand-new quote_product objects, so an assembled row that is
             * still expanded has lost the state its allocation panel lives on — the stock icon shows
             * lit with nothing under it. Re-fetch the panel for those rows.
             *
             * Here rather than only in restoreToggleStates(): that runs on the sorting paths, not on
             * this one, and this is the path a split, a merge or any order refresh comes in through.
             */
            this.hydrateExpandedAssembledPanels();
            if (this.modelOrder?.quote_product && Array.isArray(this.modelOrder.quote_product)) {
                this.hasProductWithComment();
                // ⚠️ IMPORTANT: Do NOT preserve/restore states here!
                // The parent component (quote-detail/order-detail) already handles state preservation
                // If we do it here, it creates a race condition and states get lost

                // ⚠️ IMPORTANT: Do NOT sort products here!
                // Sorting creates a new array which causes Angular to re-render the template
                // This destroys the Quill editor DOM elements
                // The parent already handles sorting during data fetch

                const parentIdsSet = new Set(
                    this.modelOrder.quote_product
                        .map((p: any) => p.parent_id)
                        .filter((id: any) => id !== null)
                );

                for (const it of this.modelOrder.quote_product) {
                    // ---------------------------------------------------------
                    // 2. NEW LOGIC: Determine Visibility Flags
                    // ---------------------------------------------------------
                    // Condition A: Is this product a Child? (Has a parent_id)
                    const isChild = it.parent_id !== null;

                    // Condition B: Is this product a Parent? (Its ID is in our parentIdsSet)
                    const isParent = parentIdsSet.has(it.id);

                    // Create a flag on the object we can use in HTML
                    // If it is a Child OR a Parent, set hideMessage to true
                    it['hideMessage'] = isChild || isParent;

                    // In-place task filtering (remove status: 'C')
                    const tasks = it.task;
                    if (tasks && tasks.length) {
                        let write = 0;
                        for (let read = 0; read < tasks.length; read++) {
                            if (tasks[read].status !== 'C') {
                                if (write !== read) tasks[write] = tasks[read];
                                write++;
                            }
                        }
                        tasks.length = write;
                    }

                    // ✅ Filter product-level tasks from pendingTasks
                    if (this.pendingTasks && this.pendingTasks.length > 0) {
                        it.productLevelTasks = this.pendingTasks.filter(
                            (task: any) => task.quote_product_id === it.id
                        );
                    } else {
                        it.productLevelTasks = [];
                    }

                    // Initialize isTasksExpanded to false if not already set
                    if (it.isTasksExpanded === undefined) {
                        it.isTasksExpanded = false;
                    }
                }

                // ✅ Check if any comments are expanded after data is loaded
                const hasExpandedComments = this.modelOrder.quote_product.some(
                    (product: any) => product.isCommentExpanded === true
                );

                this.debugLogger.log('🔍 Child: ngOnChanges - hasExpandedComments:', hasExpandedComments);
                this.debugLogger.log('🔍 Child: ngOnChanges - isQuillEditorInitialized:', this.isQuillEditorInitialized);

                // If comments are expanded but Quill editor not initialized, initialize it
                if (hasExpandedComments && !this.isQuillEditorInitialized) {
                    this.debugLogger.log('✅ Child: Auto-initializing Quill editors for expanded comments (from ngOnChanges)');
                    // Use setTimeout to ensure DOM is fully rendered
                    setTimeout(() => {
                        this.initializeQuillEditor();
                        this.isQuillEditorInitialized = true;
                    }, 0);
                }
            }
        }

        // ✅ Watch for updateQuillEditorsTrigger changes from parent
        if (changes && changes['updateQuillEditorsTrigger'] && !changes['updateQuillEditorsTrigger'].firstChange) {
            this.updateQuillEditorsContent();
        }
    }

    /**
     * ✅ Initialize Quill editors if any comments are expanded on initial load
     * This handles the case when Quick View is opened via comment icon with shouldExpandComments=true
     */
    /**
     * Re-loads the allocation panel for any assembled row left expanded without one.
     *
     * Deliberately here rather than at one specific point in a reload: an order refresh restores
     * `isStockExpanded` at different moments on different paths — a split, a merge, a socket
     * refresh, the first-row auto-expand — and hooking any single one of them left the icon lit with
     * nothing beneath it on the others. Checking after each pass is cheap (a scan of the order's
     * lines) and cannot loop, because the guard is satisfied the moment a load starts.
     */
    ngAfterViewChecked() {
        /*
         * Detect here, load OUTSIDE the pass. loadComponentBoards() calls detectChanges() straight
         * away, and doing that from within ngAfterViewChecked is how "view already checked" errors
         * happen. The detection itself is a cheap scan; the queue flag keeps it to one load per need
         * however many times this fires.
         */
        if (this.assembledHydrationQueued) {
            return;
        }
        const needsPanel = (this.modelOrder?.quote_product ?? []).some((product: any) =>
            product?.isStockExpanded
            && product?.product?.is_assembled_product
            && !product?.componentAllocation);
        if (!needsPanel) {
            return;
        }
        this.assembledHydrationQueued = true;
        Promise.resolve().then(() => {
            this.assembledHydrationQueued = false;
            this.hydrateExpandedAssembledPanels();
        });
    }

    /** Guards ngAfterViewChecked against queueing the same hydration repeatedly. */
    private assembledHydrationQueued = false;

    ngAfterViewInit() {
        // Check if any comments are expanded on initial load
        const hasExpandedComments = this.modelOrder?.quote_product?.some(
            (product: any) => product.isCommentExpanded === true
        );

        this.debugLogger.log('🔍 Child: ngAfterViewInit - hasExpandedComments:', hasExpandedComments);
        this.debugLogger.log('🔍 Child: ngAfterViewInit - isQuillEditorInitialized:', this.isQuillEditorInitialized);

        // If comments are expanded but Quill editor not initialized, initialize it
        if (hasExpandedComments && !this.isQuillEditorInitialized) {
            this.debugLogger.log('✅ Child: Auto-initializing Quill editors for expanded comments');
            // Use setTimeout to ensure DOM is fully rendered
            setTimeout(() => {
                this.initializeQuillEditor();
                this.isQuillEditorInitialized = true;
            }, 0);
        }
    }

    /**
     * Manage loading state for concurrent operations
     * Only emits to parent when overall loading state changes
     * @param operationId - Unique identifier for the operation
     * @param isLoading - Whether operation started (true) or finished (false)
     */
    private setLoadingState(operationId: string, isLoading: boolean): void {
        const wasLoading = this.loadingOperations.size > 0;

        if (isLoading) {
            this.loadingOperations.add(operationId);
        } else {
            this.loadingOperations.delete(operationId);
        }

        const isNowLoading = this.loadingOperations.size > 0;

        // Only emit to parent if overall loading state changed
        if (wasLoading !== isNowLoading) {
            this.isLoadingEvent.emit(isNowLoading);
        }

        this.changeDetection.detectChanges();
    }

    /**
     * Update UI with affected calculators from backend response
     * Backend returns ALL redistributed calculators in single response (Phase 3 optimization)
     * @param affectedCalculators - Array of calculator objects from backend
     */
    private updateUIWithAffectedCalculators(affectedCalculators: any[]): void {
        if (!affectedCalculators || affectedCalculators.length === 0) {
            return;
        }

        affectedCalculators.forEach(calc => {
            // Find the product
            const product = this.modelOrder.quote_product.find(
                (p: any) => p.id === calc.quote_product_id
            );

            if (product) {
                // Find the calculator within the product
                const calculator = product.quoteProductCalculators?.find(
                    (c: any) => c.id === calc.id || (c.type === calc.type && !c.id)
                );

                if (calculator) {
                    // Update with redistributed values from backend
                    calculator.id = calc.id;
                    calculator.total_price = calc.total_price;
                    calculator.total_unit = calc.total_unit;
                    calculator.is_selected = true;
                }
            }
        });

        // Recalculate UI totals
        toggleTotalPremiumAndAdhesiveCalculator(this.modelOrder, this.constants);
        this.changeDetection.detectChanges();
    }

    private sortQuoteProducts(items: any[]): any[] {
        if (!Array.isArray(items) || items.length === 0) return [];

        // Normalize
        for (const it of items) {
            if (Array.isArray(it.task)) {
                it.task = it.task.filter((t: any) => !this.isTaskCompleted(t));
            }
            it.isShownStatus = false;

            it.disableDragAndDrop = false;
            if (it?.quote_product_status_history?.length > 0) {
                it.disableDragAndDrop = it.quote_product_status_history.some(
                    (item) => this.disableStatusIds.has(item.status_id)
                );
            }

            if (this.modelOrder.is_split_delivery) {
                this.getSRDTooltip(it);
            }

            let ulProductDescription = '';
            if (it.ul_product_description) {
                let formatedDescription = JSON.parse(it.ul_product_description);
                ulProductDescription = formatedDescription?.ProductDescription ?? '';
            }
            it.ulProductDescription = ulProductDescription;
        }

        const roots = items.filter(it => !it.parent_id);

        roots.sort((a, b) => {
            const aOrder = a.order_index ?? 0;
            const bOrder = b.order_index ?? 0;
            if (aOrder !== bOrder) return aOrder - bOrder;
            return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        });

        const result: any[] = [];
        let rootCounter = 0;

        // Map items by id
        const itemsById = new Map<number, any>();
        items.forEach(it => itemsById.set(it.id, it));

        for (const root of roots) {
            rootCounter += 1;
            root.displayIndex = String(rootCounter);
            result.push(root);

            // Collect children recursively, flattening
            const children: any[] = [];
            const collectChildren = (parentId: number) => {
                const kids = items.filter(it => it.parent_id === parentId)
                    .sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                for (const kid of kids) {
                    children.push(kid);
                    collectChildren(kid.id);
                }
            };

            collectChildren(root.id);

            let childCounter = 0;
            for (const child of children) {
                childCounter += 1;
                child.displayIndex = `${root.displayIndex}.${childCounter}`;
                result.push(child);
            }
        }

        return result;
    }

    private isTaskCompleted(task: any): boolean {
        return task.status === Constants.TASK_COMPLETED;
    }

    // Method to manually trigger sorting for debugging
    public applySorting(): void {
        if (this.modelOrder?.quote_product && Array.isArray(this.modelOrder.quote_product)) {
            // this.debugLogger.log('Manual sort - Before:', this.modelOrder.quote_product.map(p => ({ id: p.id, order_index: p.order_index })));

            // Preserve toggle states before sorting
            const toggleStates = this.preserveToggleStates();

            this.modelOrder.quote_product = this.sortQuoteProducts([...this.modelOrder.quote_product]);
            // this.debugLogger.log('Manual sort - After:', this.modelOrder.quote_product.map(p => ({ id: p.id, order_index: p.order_index, displayIndex: p.displayIndex })));

            // Restore toggle states after sorting
            this.restoreToggleStates(toggleStates);

            this.changeDetection.detectChanges();
        }
    }

    getFormattedDiscount(discount?: number | null): string {
        const parsedDiscount = Number(discount);
        if (isNaN(parsedDiscount)) {
            return '20%';
        }
        return parsedDiscount % 1 === 0
            ? `${parsedDiscount}%`
            : `${parsedDiscount.toFixed(2)}%`;
    }

    // Convert a string to kebab-case safely for template use
    toKebabCase(value: any): string {
        if (typeof value !== 'string') {
            return '';
        }
        return value.toLowerCase().trim().replace(/\s+/g, '-');
    }

    displayAllComments() {
        if (!this.isQuillEditorInitialized) {
            this.initializeQuillEditor();
            this.isQuillEditorInitialized = true;
        }
        const comments = this.modelOrder.quote_product.filter(
            (item) => item.note && item.note.trim()
        );

        if (comments.length > 0) {
            const anyCommentExpanded = comments.some(
                (item) => item.isCommentExpanded
            );

            comments.forEach((item) => {
                if (anyCommentExpanded) {
                    item.isCommentExpanded = item.note.trim() && !item.isCommentExpanded;
                } else {
                    item.isCommentExpanded = true;
                }
            });
        } else {
            this.alertService.error(Constants.NO_COMMENTS_AVAILABLE_ERROR_MESSAGE);
        }
    }

    initializeQuillEditor() {

        // this.debugLogger.log("User", this.users);

        this.editorContainers.forEach((container, index) => {
            const quillEditor = new Quill(container.nativeElement, {
                modules: {
                    toolbar: false,
                    mention: {
                        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                        mentionDenotationChars: ['@'],
                        source: (searchTerm, renderList, mentionChar) => {
                            if (!quillEditor.isEnabled()) {
                                return;
                            }
                            if (mentionChar === '@') {
                                const matches = this.users.filter((user) =>
                                    user.value?.toLowerCase().includes(searchTerm.toLowerCase())
                                );
                                renderList(matches, searchTerm);
                            }
                        },
                        onSelect: (item, insertItem) => {
                            const user = this.users.find((u) => u.value === item.value);
                            if (user) {
                                // this.selectedUsers.push(user);
                                // Initialize selectedUsers as an object if it's not already initialized
                                if (!this.selectedUsers) {
                                    this.selectedUsers = [];
                                }
                                // Ensure there's an array for the specific container ID
                                if (!this.selectedUsers[container.nativeElement.id]) {
                                    this.selectedUsers[container.nativeElement.id] = [];
                                }
                                // Push the user into the array for the specific container ID
                                this.selectedUsers[container.nativeElement.id].push(user);
                                insertItem(item);
                            }
                        },
                    },
                },
                placeholder: this.setCommentPlaceholder(null),
                theme: 'snow',
            });
            this.updateEditorState(quillEditor);
            // Set the Quill editor instance in the containers map
            this.quillEditorContainers[container.nativeElement.id] = quillEditor;

            /* ################### Set Existing Content From Database Into Editor Start ################### */
            if (this.modelOrder?.quote_product?.[index]?.note) {
                quillEditor.setContents(
                    quillEditor.clipboard.convert({ html: this.modelOrder.quote_product[index].note })
                );
                this.message = this.modelOrder.quote_product[index].note;
                this.updateEditorState(quillEditor);

                const editorContent = this.getContentWithMentions(
                    this.modelOrder?.quote_product[index]?.id
                );
                this.updateSelectedUsers(
                    editorContent,
                    this.modelOrder.quote_product[index].id,
                    true
                );
            }
            /* ################### Set Existing Content From Database Into Editor End ################### */

            quillEditor.on('text-change', () => {
                const editorContent = this.getContentWithMentions(
                    this.modelOrder.quote_product[index].id
                );
                let content = quillEditor.root.innerHTML;
                if (content === '<p><br></p>') {
                    content = ''; // Treat the editor as empty if it contains only <p><br></p>
                }
                this.modelOrder.quote_product[index].note = content;
                this.updateSelectedUsers(
                    editorContent,
                    this.modelOrder.quote_product[index].id
                );
            });

            quillEditor.root.addEventListener('keyup', () =>
                this.handleEditorEvent(index)
            );
            quillEditor.root.addEventListener('click', () =>
                this.handleEditorEvent(index)
            );
            // Optional: Listen to Quill's text-change event, which captures all changes
            quillEditor.on('text-change', () => this.handleEditorEvent(index));
            // Listen for keyup events and call the specified function
        });
    }

    handleEditorEvent(index: number) {
        clearTimeout(this.keyupTimeout);
        // Set a new timeout
        this.keyupTimeout = setTimeout(() => {
            this.onCommentKeyUp(
                this.modelOrder.quote_product[index].note,
                this.modelOrder.quote_product[index].id,
                this.modelOrder.quote_product[index].old_note
            );
        }, 2000); // 2000 milliseconds = 2 seconds
    }

    setCommentPlaceholder(comment: any) {
        if (comment) {
            return comment;
        }
        if (
            !comment &&
            (this.isOrderCancel || this.isQuoteCancel ||
                this.modelOrder?.is_archive == Constants.IS_ARCHIVE_YES)
        ) {
            return 'No comment added';
        }
        if (!comment && !this.isOrderCancel && !this.isQuoteCancel) {
            return 'Add your comment here...';
        }
    }

    updateEditorState(quillEditor: Quill) {
        if (this.isQuoteCancel || this.isOrderCancel || this.modelOrder?.is_archive || this.modelOrder?.is_expired || this.isQuoteUnconverted) {
            quillEditor.enable(false);
            quillEditor.container.classList.add('disabled-editor'); // Add disabled class
        } else {
            quillEditor.enable(true);
            quillEditor.container.classList.remove('disabled-editor'); // Remove disabled class
        }
    }

    onCommentKeyUp(comment: string, id: number, oldNote: string) {
        this.commentUpdateSubject.next({comment, id, oldNote});
        this.hasProductWithComment();
    }

    hasProductWithComment() {
        this.containsComment = this.modelOrder?.quote_product.some((item) => item.note && item.note.trim());
    }

    removeSpaces(input: string): string {
        // Remove HTML tags
        let noHtml = input.replace(/<[^>]*>/g, '');
        // Remove spaces
        return noHtml.replace(/\s+/g, '');
    }

    addUpdateQuoteProductComment(quoteProductComment: any, productId: number, oldNote) {
        const trimmedValue = this.removeSpaces(quoteProductComment);

        // Condition 1: If oldNote is empty and user adds only spaces
        if (!oldNote && !trimmedValue) {
            return;
        }

        // Condition 2: If oldNote is empty and user adds spaces with some digit or character
        if (!oldNote && trimmedValue) {
            this.callQuoteProductCommentApi(quoteProductComment, productId);
            return;
        }

        // Condition 3: If oldNote is not empty and user removes value of quoteProductComment
        if (oldNote && !trimmedValue) {
            this.callQuoteProductCommentApi(quoteProductComment, productId);
            return;
        }

        // Condition 4: If oldNote is not empty, user removes value, and then adds spaces or some digit/character
        if (oldNote && quoteProductComment.trim() !== oldNote.trim()) {
            if (!trimmedValue) {
                return;
            } else {
                this.callQuoteProductCommentApi(quoteProductComment, productId);
                return;
            }
        }
    }

    getProductById(productId: number) {
        return this.productDetail.find((item) => item.id === productId);
    }

    callQuoteProductCommentApi(comment: string, id: number): void {
        this.isLoadingEvent.emit(true);
        let json = {
            note: comment,
            only_change_note: true,
        };

        let modifiedproduct = this.getProductById(id);

        this.quoteService.updateQuoteProduct(json, id).subscribe(
            (res: any) => {
                if (!modifiedproduct.note) {
                    this.alertService.success(Constants.ADD_COMMENT_SUCCESS_MESSAGE);
                } else {
                    this.alertService.success(Constants.UPDATE_COMMENT_SUCCESS_MESSAGE);
                }

                const note = res.note;
                if (note.includes('@')) {
                    this.sendNotification(res);
                }
                /* ################### Delete Notification For Removed User Start ################### */
                if (Array.isArray(this.removedUsers[res.id]) && this.removedUsers[res.id].length > 0) {
                    for (let index = this.removedUsers[res.id].length - 1; index >= 0; index--) {
                        const removedUser = this.removedUsers[res.id][index];

                        if (this.quoteProductExistingNotifications && this.quoteProductExistingNotifications[res.id]) {
                            const existingNotificationObj = this.quoteProductExistingNotifications[res.id].find((notification) => notification.quote_product_id === res.id && notification.to_user_id === removedUser.id);

                            if (existingNotificationObj?.id > 0) {
                                // Delete the notification
                                this.notificationService
                                    .deleteNotification(existingNotificationObj.id)
                                    .subscribe(() => {
                                            // Remove the user from removedUsers array after successful deletion
                                            this.removedUsers[res.id].splice(index, 1);
                                            this.subscribersService.updateUnreadNotification(
                                                this.unReadNotificationCount.toString()
                                            );
                                            // Handle delete response if needed
                                        }
                                    );
                            }
                        }
                    }
                }
                /* ################### Delete Notification For Removed User End ################### */

                const responseProductId = res.id;
                const responseUpdatedNote = res.note;

                let productToUpdate = this.modelOrder.quote_product.find((item) => item.id === responseProductId);
                if (productToUpdate) {
                    productToUpdate.old_note = this.removeSpaces(responseUpdatedNote);
                    productToUpdate.note = responseUpdatedNote;
                }

                this.isLoadingEvent.emit(false);

                // ✅ Emit socket event for product comment update (real-time synchronization)
                this.debugLogger.log('💬 Product comment added/updated - emitting socket event');
                this.webSocketService.emit('quote_updated', {
                    quoteId: this.modelOrder.id,
                    exportId: this.modelOrder.export_id
                });
                if (this.modelOrder.type == Constants.ORDER_TYPE_QUOTE_SHORT) {
                    this.webSocketService.emit('quote_created', true);
                } else {
                    this.webSocketService.emit('order_created', true);
                }
            },
            (error) => {
                this.isLoadingEvent.emit(false);
            }
        );
    }

    sendNotification(response: any) {
        /* ################### Send Notification To Selected Users Start ################### */
        if (Array.isArray(this.selectedUsers[response.id]) && this.selectedUsers[response.id].length > 0) {
            const editorContent = this.getContentWithMentions(response.id);

            // Regex pattern to match mentions in the format {{mention:Name}}
            const mentionRegex = /{{mention:([\w\s]+?)}}/g;

            // Remove mentions from the original note to get the message part
            let messagePart = editorContent.replace(mentionRegex, '').trim();

            // Iterate over selected users to send notifications
            this.selectedUsers[response.id]?.forEach((user: any) => {
                const mention = `@${user.value}`;

                // Construct the message string for this user
                const notificationMessage = `<span class="mention">${mention}</span> ${messagePart}`;

                // Prepare the request model for sending notification
                const requestModel: any = {
                    message: notificationMessage,
                    quote_product_id: response.id, // Adjust as per your response structure
                    from_user_id: this.loginUserId,
                    type: Constants.QUOTE_PRODUCT_NOTIFICATION,
                    to_user_id: user.id,
                };

                // Send notification with updated message containing mentions
                this.notificationService
                    .sendNotification(requestModel)
                    .subscribe((notificationResponse) => {
                        // Handle notification response if needed
                        if (this.quoteProductExistingNotifications?.length > 0) {
                            // Check if element.id already exists in the array
                            const exists = this.quoteProductExistingNotifications[response.id]?.find((item) => item?.id === notificationResponse.id);
                            if (exists) {
                                // Add new notification to the existing array
                                this.quoteProductExistingNotifications[response.id].push(notificationResponse);
                            } else {
                                // Ensure that this.quoteProductExistingNotifications[response.id] is initialized as an array
                                if (!Array.isArray(this.quoteProductExistingNotifications[response.id])) {
                                    this.quoteProductExistingNotifications[response.id] = [];
                                }
                                // Add new notification to the existing array
                                this.quoteProductExistingNotifications[response.id].push(notificationResponse);
                            }
                        } else {
                            // Ensure that this.quoteProductExistingNotifications[response.id] is initialized as an array
                            if (!Array.isArray(this.quoteProductExistingNotifications[response.id])) {
                                this.quoteProductExistingNotifications[response.id] = [];
                            }

                            // Add new notification to the existing array
                            this.quoteProductExistingNotifications[response.id].push(notificationResponse);
                        }
                        this.subscribersService.updateUnreadNotification(this.unReadNotificationCount.toString());
                    });
            });
        }
        /* ################### Send Notification To Selected Users End ################### */
    }

    getContentWithMentions(id: number): any {
        let content = '';
        if (this.quillEditorContainers?.length > 0 && id > 0) {
            if (this.quillEditorContainers[id]) {
                const delta = this.quillEditorContainers[id].getContents();
                delta.ops.forEach((op) => {
                    if (typeof op.insert === 'string') {
                        content += op.insert;
                    } else if (op.insert.mention) {
                        content += `{{mention:${(op.insert.mention as any).value}}} `;
                    }
                });
            }
        }
        return content.trim();
    }

    updateSelectedUsers(editorContent: string, containerId: any = null, isSetExistingUser = false) {
        if (containerId === null || containerId <= 0) {
            return;
        }

        const mentionRegex = /{{mention:([\w\s]+?)}}/g;
        const mentionedUserValues: string[] = [];
        let match;

        while ((match = mentionRegex.exec(editorContent)) !== null) {
            mentionedUserValues.push(match[1].trim());
        }

        if (!isSetExistingUser) {
            // Ensure this.selectedUsers[containerId] is initialized
            if (!this.selectedUsers[containerId]) {
                this.selectedUsers[containerId] = [];
            }

            // Get current selected user values
            const currentSelectedUserValues = this.selectedUsers[containerId]?.map((user) => user.value) || [];

            // Identify users to add to selectedUsers
            const usersToAdd = this.users.filter(
                (user) =>
                    mentionedUserValues.includes(user.value) &&
                    !currentSelectedUserValues.includes(user.value)
            );

            // Identify users to be removed from selectedUsers
            const usersToRemove =
                this.selectedUsers[containerId]?.filter(
                    (user) => !mentionedUserValues.includes(user.value)
                ) || [];

            // Update selectedUsers
            this.selectedUsers[containerId] = [
                ...this.selectedUsers[containerId].filter((user) =>
                    mentionedUserValues.includes(user.value)
                ),
                ...usersToAdd,
            ];

            // Ensure this.removedUsers[containerId] is initialized
            if (!this.removedUsers[containerId]) {
                this.removedUsers[containerId] = [];
            }

            // Store removed users if they are not already in removedUsers[containerId]
            usersToRemove.forEach((user) => {
                if (!this.removedUsers[containerId].some((r) => r.id === user.id)) {
                    this.removedUsers[containerId].push({
                        id: user.id,
                        name: user.value,
                    });
                }
            });

            // Clean up removedUsers by removing users that are still selected
            this.removedUsers[containerId] = this.removedUsers[containerId].filter(
                (removedUser) =>
                    !this.selectedUsers[containerId].some(
                        (selectedUser) => selectedUser.id === removedUser.id
                    )
            );
        } else {
            if (mentionedUserValues) {
                this.selectedUsers[containerId] = this.users.filter((user) =>
                    mentionedUserValues.includes(user.value)
                );
            }
        }
    }

    /**
     * True only while a consumables-only record genuinely carries NO delivery charge.
     *
     * It suppresses the "your manual delivery fee will be invalidated" confirmation. That warning was
     * a false alarm on a consumables record, which sits at truck type "Other" with a $0 rate and was
     * read by the condition below as a hand-keyed fee.
     *
     * Since 29 Sep 2026 an admin MAY key a delivery charge on such a record, and once one exists the
     * warning is no longer a false alarm — there is a real manual fee that a quantity change would
     * invalidate — so the suppression is lifted the moment a charge is present.
     *
     * Offline (Unleashed-fed) records were never exempt: they carry whatever charge Unleashed set.
     */
    get isFreeDeliveryConsumablesRecord(): boolean {
        if (!this.modelOrder?.is_consumable_order || this.modelOrder?.is_offline_order) {
            return false;
        }
        const rate = Number(
            this.modelOrder?.quote_summary?.shipping_rate ?? this.modelOrder?.shipping_rate ?? 0
        );
        return !(rate > 0);
    }

    toggleAddItemSideBar(event: MouseEvent) {
        event.preventDefault();
        if (this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES) {
            this.alertService.error(this.isOrderDetail ? Constants.UNABLE_ORDER_DETAIL_CHANGE : Constants.UNABLE_QUOTE_DETAIL_CHANGE);
            return false;
        }
        if (this.modelOrder?.is_expired === Constants.QUOTE_IS_EXPIRED_YES) {
            this.alertService.error(Constants.UNABLE_QUOTE_STATUS_CHANGE_WITH_EXPIRED);
            return false;
        }
        if (this.modelOrder?.status?.short_name === Constants.ORDER_DELIVERD_SHORT || this.modelOrder?.status?.short_name === Constants.ORDER_FOLLOW_UP_SHORT) {
            this.alertService.error(Constants.UNABLE_DELIVERED_QUOTE_PRODUCT_ADD);
            return;
        }
        if (this.modelOrder?.status?.short_name === Constants.ORDER_COMPLETED_SHORT) {
            this.alertService.error(Constants.UNABLE_COMPLETED_QUOTE_PRODUCT_ADD);
            return;
        }

        // Create and assign model
        this.productModel = new ProductModel();
        this.productModel.type = Constants.SURFACE_SORT_NAME;

        this.is_open_addItem_sidebar = true

        if (!this.isFreeDeliveryConsumablesRecord && ((this.modelOrder.is_expired !== Constants.QUOTE_IS_EXPIRED_YES && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT && this.modelOrder?.quote_summary?.shipping_rate != null && this.modelOrder?.quote_summary?.shipping_rate >= 0 && this.isQuoteAccepted) || (this.modelOrder?.defaultQuoteAddress?.shipping_truck_type_id != Constants.OTHER_TRUCK_ID && this.modelOrder.is_expired !== Constants.QUOTE_IS_EXPIRED_YES && this.modelOrder?.defaultQuoteAddress?.in_shipping_zone === Constants.IN_SHIPPING_ZONE_NO && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT && this.modelOrder?.quote_summary?.shipping_rate != null && this.modelOrder?.quote_summary?.shipping_rate >= 0 && !this.isQuoteAccepted) || (this.modelOrder?.defaultQuoteAddress?.in_shipping_zone == null && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT && this.modelOrder?.quote_summary?.shipping_rate != null && this.modelOrder?.quote_summary?.shipping_rate == 0) || this.modelOrder?.quote_summary?.is_manual_shipping_rate_change == Constants.IS_MANUAL_SHIPPING_RATE_CHANGE_YES) && this.modelOrder?.defaultQuoteAddress?.is_warehouse_collection == Constants.IS_WAREHOUSE_COLLECTION_NO) {
            let modalRef: BsModalRef = this.modalService.show(ConfirmModalComponent, {
                backdrop: 'static',
                ignoreBackdropClick: true,
                keyboard: false
            });
            modalRef.content.title = 'Alert';
            modalRef.content.message = Constants.UPDATE_PRODUCT_QUANTITY_AFTER_DELIVERY_CHARGE_ADDED_MESSAGE(this.modelOrder?.type === Constants.ORDER_TYPE_ORDER_SHORT ? 'order' : 'quote');
            modalRef.setClass('delete-modal-custom');
            modalRef.content.onClose.subscribe((result: any) => {
                if (result) {
                    this.itemSidebarEvent.emit(event);
                    this.subscribersService.resetAddItemSidebarToggle(true);
                    event.stopPropagation();
                    this.subscribersService.emitAddItemSidebarClick(true);
                    setTimeout(() => {
                        this.subscribersService.addItemSidebarToggle(true);
                    }, 500);
                }
            });
        } else {
            this.itemSidebarEvent.emit(true);
            event.stopPropagation();
            this.productAccessories = [];
            this.subscribersService.emitAddItemSidebarClick(true);
            setTimeout(() => {
                this.subscribersService.addItemSidebarToggle(true);
            }, 500);
        }
    }

    checkQuantityOnKeyPress(productsRow: any, qtyChangeType: any, enteredQuantity: any = 0) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.checkQuantity(productsRow, qtyChangeType, enteredQuantity);
        }, 1500);
    }

    checkQuantity(productsRow: any, qtyChangeType: any, enteredQuantity: any = 0) {
        if (this.isOrderCancel) {
            return false;
        }

        // The minus is disabled at 1 on a consumable line; this stops any other route to it too,
        // before a confirmation pop-up is shown for a change that would only be refused.
        if (qtyChangeType === 'decrement' && this.isConsumableMinusDisabled(productsRow)) {
            return false;
        }

        if (this.modelOrder?.is_archive && this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES) {
            this.alertService.error(this.isOrderDetail ? Constants.UNABLE_ORDER_DETAIL_CHANGE : Constants.UNABLE_QUOTE_DETAIL_CHANGE);
            return false;
        }

        if (this.modelOrder?.is_expired && this.modelOrder?.is_expired === Constants.QUOTE_IS_EXPIRED_YES) {
            this.alertService.error(Constants.UNABLE_QUOTE_STATUS_CHANGE_WITH_EXPIRED);
            return false;
        }
        const deliveryStatuses = [Constants.ORDER_DELIVERY_UNCONFIRMED, Constants.ORDER_DELIVERY_OUT_TO_TENDER_SHORT, Constants.ORDER_DELIVERY_CONFIRMED_SHORT, Constants.ORDER_DELIVERY_CLIENT_ORGANIZED_SHORT, Constants.ORDER_DELIVERY_DISPATCHED_SHORT];
        if (deliveryStatuses.includes(this.modelOrder?.status?.short_name) || (this.modelOrder.is_split_delivery && deliveryStatuses.includes(productsRow?.status_quote_product?.short_name))) {
            this.alertService.error(Constants.UNABLE_UNASSIGNED_QUOTE_PRODUCT_CHANGE);
            return;
        }
        if (this.modelOrder?.status?.short_name === Constants.ORDER_DELIVERD_SHORT || this.modelOrder?.status?.short_name === Constants.ORDER_FOLLOW_UP_SHORT || (this.modelOrder.is_split_delivery && productsRow?.status_quote_product?.short_name === Constants.ORDER_DELIVERD_SHORT)) {
            this.alertService.error(Constants.UNABLE_DELIVERED_QUOTE_PRODUCT_CHANGE);
            return;
        }
        if (this.modelOrder?.status?.short_name === Constants.ORDER_COMPLETED_SHORT) {
            this.alertService.error(Constants.UNABLE_COMPLETED_QUOTE_PRODUCT_CHANGE);
            return;
        }

        if (this.modelOrder.quote_summary?.applied_credit > 0 && this.modelOrder.type === Constants.ORDER_TYPE_QUOTE_SHORT) {
            this.modalRef = this.modalService.show(ConfirmModalComponent);
            this.modalRef.content.title = 'Confirm Quantity Update';
            // this.modalRef.content.message = Constants.UPDATE_PRODUCT_QUANTITY_AFTER_CREDIT_APPLIED.BODY_MESSAGE;
            this.modalRef.content.message = Constants.UPDATE_PRODUCT_QUANTITY_AFTER_CREDIT_APPLIED_MESSAGE(this.modelOrder?.type === Constants.ORDER_TYPE_ORDER_SHORT ? 'order' : 'quote');
            this.modalRef.setClass('delete-favourite-modal');
            this.modalRef.content.onClose.subscribe((result: any) => {
                if (result !== false && result !== undefined) {
                    this.changeQuantity(productsRow, qtyChangeType, enteredQuantity, true);
                }
            });
        } else {
            // Display confirmation pop up if manual delivery quote applied (only for Quote type, Orders auto-create "Revise Quote Delivery" task)
            // Consumables ship free by rule, so there is never a manual delivery fee to invalidate —
            // see isFreeDeliveryConsumablesRecord. Without this gate the warning fired on EVERY
            // quantity change to a consumables quote, because such a record is always truck type
            // Other with a $0 rate and the last clause below reads that as a hand-keyed fee.
            if (!this.isFreeDeliveryConsumablesRecord && this.modelOrder.type === Constants.ORDER_TYPE_QUOTE_SHORT && ((this.modelOrder.is_expired !== Constants.QUOTE_IS_EXPIRED_YES && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT && this.modelOrder.quote_summary?.shipping_rate != null && this.modelOrder.quote_summary?.shipping_rate >= 0 && this.isQuoteAccepted) || (this.modelOrder?.defaultQuoteAddress?.shipping_truck_type_id != Constants.OTHER_TRUCK_ID && this.modelOrder.is_expired !== Constants.QUOTE_IS_EXPIRED_YES && this.modelOrder?.defaultQuoteAddress?.in_shipping_zone === Constants.IN_SHIPPING_ZONE_NO && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT && this.modelOrder?.quote_summary?.shipping_rate != null && this.modelOrder?.quote_summary?.shipping_rate >= 0 && !this.isQuoteAccepted) || (this.modelOrder?.defaultQuoteAddress?.in_shipping_zone == null && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT && this.modelOrder.quote_summary?.shipping_rate != null && this.modelOrder.quote_summary?.shipping_rate == 0) || this.modelOrder.is_manual_shipping_rate_change == Constants.IS_MANUAL_SHIPPING_RATE_CHANGE_YES || this.modelOrder?.defaultQuoteAddress?.shipping_truck_type_id == Constants.OTHER_TRUCK_ID) && this.modelOrder?.defaultQuoteAddress?.is_warehouse_collection == Constants.IS_WAREHOUSE_COLLECTION_NO) {
                this.modalRef = this.modalService.show(ConfirmModalComponent);
                this.modalRef.content.title = 'Update Quantity';
                // this.modalRef.content.message = Constants.UPDATE_PRODUCT_QUANTITY_AFTER_DELIVERY_CHARGE_ADDED.BODY_MESSAGE;
                this.modalRef.content.message = Constants.UPDATE_PRODUCT_QUANTITY_AFTER_DELIVERY_CHARGE_ADDED_MESSAGE(this.modelOrder?.type === Constants.ORDER_TYPE_ORDER_SHORT ? 'order' : 'quote');
                this.modalRef.setClass('delete-favourite-modal');
                this.modalRef.content.onClose.subscribe((result: any) => {
                    if (result !== false && result !== undefined) {
                        if (this.modelOrder?.quoteStatus?.quote_status === Constants.QUOTE_MANUAL_DELIVERY_QUOTE_APPLIED_SHORT && this.modelOrder.is_manual_shipping_rate_change !== null) {
                            this.isManualShippingRateChange = true;
                        }
                        this.changeQuantity(productsRow, qtyChangeType, enteredQuantity);
                    }
                });
            } else {
                this.changeQuantity(productsRow, qtyChangeType, enteredQuantity);
            }
        }
    }

    async changeQuantity(productsRow: any, qtyChangeType: any, enteredQuantity: any = 0, resetAppliedCredit = false) {
        // A standalone consumable line (consumable_id set, no product_id) has no parent product row,
        // so productsRow.product is null. Reading .moi off it threw a TypeError before any request
        // was made — which is why editing a consumable line's quantity on the detail screen updated
        // the box on screen and saved nothing. Consumables are sold in whole units, so MOI is 1.
        const isConsumableLine = !!productsRow?.consumable_id && !productsRow?.product_id;
        let moi = productsRow?.product?.moi || 1;
        let currentQtyValue = productsRow?.quantity;
        // Quantity this line already holds, captured BEFORE the edit below overwrites
        // productsRow.quantity. On an ORDER the line sits on an Unleashed sales order, so
        // ul_available_qty (QtyOnHand - AllocatedQty) already has this amount deducted — it must
        // be added back or the line is capped against its own allocation and can never grow.
        // Quotes are not pushed to Unleashed, so nothing is deducted for them and nothing is
        // added back (adding back there would inflate the ceiling and invite over-allocation).
        const allocatedToThisLine = this.modelOrder?.type === Constants.ORDER_TYPE_ORDER_SHORT
            ? (Number(productsRow?.quantity) || 0)
            : 0;
        if (qtyChangeType == 'increment') {
            currentQtyValue = (+currentQtyValue + 1);
        } else if (qtyChangeType == 'decrement' && currentQtyValue > 0) {
            currentQtyValue = (+currentQtyValue - 1);
            if (currentQtyValue < 0) {
                currentQtyValue = 0;
            }
        } else if (qtyChangeType == 'text' && currentQtyValue >= 0) {
            currentQtyValue = enteredQuantity;
        } else if (qtyChangeType == 'click' && currentQtyValue >= 0) {
            // Full-precision moi multiple; display up to 4dp (trailing zeros trimmed).
            currentQtyValue = formatMoiQty(snapUpToMoi(currentQtyValue, moi), 4);
        }
        if (qtyChangeType != 'click' && currentQtyValue >= 1) {
            productsRow.clickesQuantity = formatMoiQty(snapUpToMoi(currentQtyValue, moi), 4);
        }

        let quantity = currentQtyValue;

        // Persist at up to 4dp (was toFixed(2), which truncated 4-decimal-MOI
        // quantities on +/- and edit). Matches quote-create / quote-clone.
        productsRow.quantity = formatMoiQty(quantity, 4);
        this.changeDetection.detectChanges();
        this.checkStockAvailability(productsRow, undefined, undefined, allocatedToThisLine);

        let json: any = {
            quantity: productsRow.quantity,
            discount: productsRow.discount,
            price: productsRow.price,
            quote_id: productsRow?.quote_id,
            // product_id and consumable_id are mutually exclusive on a quote_product row; sending a
            // null product_id for a consumable line trips the backend's XOR validator.
            ...(isConsumableLine
                ? {consumable_id: productsRow.consumable_id}
                : {product_id: productsRow?.product_id}),
            ...(productsRow.discounted_price != null ? {discounted_price: productsRow.discounted_price} : {}),
            ...(productsRow.includeWastage ? {wastage_percentage: productsRow.currentWastage} : {})
        };

        if (this.modelOrder.type === Constants.ORDER_TYPE_QUOTE_SHORT) {
            this.modelOrder.quote_summary.applied_credit = 0;
            json.applied_credit = 0;
        }

        if (this.debounceTimers[productsRow.id]) {
            clearTimeout(this.debounceTimers[productsRow.id]);
        }
        this.debounceTimers[productsRow.id] = setTimeout(async () => {
            try {
                // Only show loader when we are actually going to the server
                this.isLoadingEvent.emit(true);

                await this.updateQuoteQuantity(json, productsRow.id);
                this.toggleTotalPremiumAndAdhesiveCalculator();

                if (this.modelOrder.type === Constants.ORDER_TYPE_ORDER_SHORT) {
                    await firstValueFrom(this.quoteService.splitProduction({id: this.modelOrder.id}));
                }

                this.getOrderEvent.emit(false);
                // Recalculate consumable summary
                this.calculateConsumableSummary();

                // await this.getShippingCost1(productsRow).then(async (response: any) => {
                //   this.debugLogger.log('response:: ', response)
                //   if (productsRow.quote_schedule_delivery_product?.quote_schedule_delivery_id) {
                //     let request: any = {
                //       crates: response.no_of_pallet
                //     }
                //     if (response.in_shipping_zone || response.address?.is_warehouse_collection) {
                //       request.is_manual_shipping_rate_change = null;
                //     }
                //     await this.updateQuoteScheduleDelivery(productsRow.quote_schedule_delivery_product?.quote_schedule_delivery_id, request);
                //   }
                //   if (response.address?.id) {
                //     await this.updateQuoteAddress(response);
                //   }
                // });
                // await this.getConsumableCalculators(productsRow.product_id, parseInt(productsRow.quantity), false).then(async () => {
                //   await this.updateQuoteProductAppliedCalculator(false);
                // }).then(() => {
                //   this.toggleTotalPremiumAndAdhesiveCalculator();
                // }).then(async () => {
                //   //   await this.updateStatusOnAddressOrProductChange();
                //   // }).then(async () => {
                //
                //   if (this.modelOrder.type === Constants.ORDER_TYPE_ORDER_SHORT) {
                //     await firstValueFrom(this.quoteService.splitProduction({id: this.modelOrder.id}));
                //   }
                //
                //   await this.updateOrderSummary(this.modelOrder.id, resetAppliedCredit);
                //   if (this.modelOrder.type === Constants.ORDER_TYPE_ORDER_SHORT && !this.isOfflineOrder) {
                //     await this.syncDeliveryWithUnleashed();
                //     await this.syncProductWithUnleashed();
                //     await this.syncAdditionalDeliveryDetailWithUnleashed();
                //   }
                //   if (this.modelOrder.type === Constants.ORDER_TYPE_QUOTE_SHORT) {
                //     await this.updateStatusOnAddressOrProductChange();
                //   }
                // }).then(async () => {
                //   this.getOrderEvent.emit(false);
                //   // }).then(async () => {
                //   //   const requestParamContestModel = new RequestParamModel();
                //   //   requestParamContestModel.expands = ['quoteOverallSealerUnit'];
                //   //   delete requestParamContestModel.pageSize;
                //   //   this.quoteService.getQuoteDetail(this.modelOrder.id, requestParamContestModel).subscribe((dataList: QuoteOrderSampleModel) => {
                //   //     this.modelOrder.subtotal = dataList.subtotal;
                //   //     this.modelOrder.applied_discount = dataList.applied_discount;
                //   //     this.modelOrder.shipping_rate = dataList.shipping_rate;
                //   //     this.modelOrder.tax_gst = dataList.tax_gst;
                //   //     this.modelOrder.applied_credit = dataList.applied_credit;
                //   //     this.modelOrder.final_total = dataList.final_total;
                //   //     this.modelOrder.no_of_pallet = dataList.no_of_pallet;
                //   //     this.modelOrder.quoteOverallSealerUnit = dataList.quoteOverallSealerUnit;
                //   //   });
                // }).then(() => {
                //   // Recalculate consumable summary
                //   this.calculateConsumableSummary();
                // });
            } catch (error) {
                console.error('Error updating quantity:', error);
            } finally {
                // ✅ STOP LOADING: Ensure loader stops after success or error
                this.isLoadingEvent.emit(false);
                delete this.debounceTimers[productsRow.id];
            }
        }, 500);
    }

    checkStockAvailability(productsRow: any, quoteProduct?: any, isFromSidebar?: any, allocatedToThisLine: number = 0) {
        // A standalone consumable line has nothing to check and no product row to read.
        //
        // This method exists solely to cap a SALE product against Unleashed's available quantity —
        // every branch below is gated on is_sale === YES. A consumable is never a sale product, is
        // not allocated on an Unleashed sales order, and carries no ul_available_qty; it also has no
        // `product` row at all, so the destructure below threw a TypeError on `is_sale` and killed
        // the quantity change before any request went out. Returning early rather than defaulting
        // the destructure is deliberate: with ul_available_qty undefined, maxAllowedQty resolves to
        // 0 and the cap would rewrite the line's quantity down to 0.
        if (!isFromSidebar && productsRow?.consumable_id && !productsRow?.product_id) {
            return;
        }
        const {
            is_sale,
            ul_available_qty
        } = isFromSidebar ? (productsRow.type === Constants.PRODUCT_TYPE_SURFACE_ACCESSORY ? productsRow.productDetail : productsRow) : productsRow.product;
        // Unleashed reports AvailableQty = QtyOnHand - AllocatedQty. When the line being edited is
        // already on the sales order, its own quantity is inside AllocatedQty, so capping at the
        // raw AvailableQty counts the line against itself: raising it raises AllocatedQty, which
        // lowers AvailableQty by the same amount, and the cap just oscillates. Adding the line's
        // own allocation back gives the real ceiling. Defaults to 0, so every existing caller
        // (new items, quotes) keeps today's behaviour exactly.
        // Floored at the line's own allocation (and at 0) so an over-allocated or zero-stock
        // product can never silently rewrite a line down to 0 or to a negative quantity — which
        // is what the raw AvailableQty does today when it is <= 0. A line may always keep what it
        // already holds; reducing it is a business decision, not something a cap should force.
        const ownAllocation = Number(allocatedToThisLine) || 0;
        const maxAllowedQty = Math.max(Number(ul_available_qty) + ownAllocation, ownAllocation, 0);
        if (is_sale === Constants.IS_YES && isFromSidebar && Number(quoteProduct.quantity) > maxAllowedQty) {
            quoteProduct.quantity = maxAllowedQty.toFixed(2);
        } else if (!isFromSidebar && is_sale === Constants.IS_YES && Number(productsRow.quantity) >= maxAllowedQty) {
            productsRow.quantity = maxAllowedQty.toFixed(2);
            this.changeDetection.detectChanges();
        }
    }

    async getShippingCost1(productsRow): Promise<unknown> {
        return new Promise((resolve) => {
            let model: any = {};
            // this.debugLogger.log('productsRow:: ', productsRow)
            let address: any;

            if (this.modelOrder.is_split_delivery) {
                // this.debugLogger.log('this.modelOrder.quote_product:: ', this.modelOrder.quote_product)
                address = productsRow.quote_schedule_delivery_product?.quote_schedule_delivery?.quote_address;
                if (address?.address_line_1 && address?.address_line_1 !== '') {
                    model.post_code = Number(address?.post_code);
                    model.suburb = address?.suburb;
                    if (address?.shipping_truck_type_id) {
                        model.shipping_truck_type_id = address.shipping_truck_type_id;
                    }
                    const products = this.modelOrder?.quote_product
                        .filter(item => item.quote_schedule_delivery_product?.quote_schedule_delivery_id === productsRow.quote_schedule_delivery_product?.quote_schedule_delivery_id)
                        .map(element => ({
                            product_id: element.product_id,
                            price: element.price,
                            quantity: Number(element.quantity)
                        }));
                    model.products = products;
                } else {
                    resolve(true);
                    return;
                }
            } else {
                address = this.modelOrder.quote_address?.[0];
                if (address?.address_line_1 && address?.address_line_1.trim() !== '') {
                    model.post_code = Number(address?.post_code);
                    model.suburb = address?.suburb;
                    if (address?.shipping_truck_type_id) {
                        model.shipping_truck_type_id = address.shipping_truck_type_id;
                    }
                    let products: any[] = [];
                    if (this.modelOrder?.quote_product?.length > 0) {
                        this.modelOrder.quote_product.forEach((element: any) => {
                            products.push({
                                product_id: element.product_id,
                                price: element.price,
                                quantity: Number(element.quantity),
                            });
                        });
                    }
                    model.products = products;
                } else {
                    resolve(true);
                    return;
                }
            }

            this.orderService.getShippingCost(model).subscribe((detail: any) => {
                    if (detail) {
                        if (this.modelOrder?.type === Constants.ORDER_TYPE_ORDER_SHORT && this.modelOrder?.defaultQuoteAddress && this.modelOrder?.defaultQuoteAddress?.in_shipping_zone !== Constants.IN_SHIPPING_ZONE_NO) {
                            this.modelOrder.quote_summary.shipping_rate = detail.shipping_rate;
                        }

                        if (address.in_shipping_zone === Constants.IN_SHIPPING_ZONE_YES) {
                            this.modelOrder.is_manual_shipping_rate_change = null;
                            this.isManualShippingRateChange = false;
                        } else {
                            this.isManualShippingRateChange = this.modelOrder.quote_summary.shipping_rate ? true : false;
                        }

                        if (address.is_warehouse_collection === Constants.IS_WAREHOUSE_COLLECTION_YES) {
                            this.modelOrder.quote_summary.shipping_rate = 0;
                        }
                        if (this.modelOrder?.type === Constants.ORDER_TYPE_QUOTE_SHORT || (this.modelOrder?.type === Constants.ORDER_TYPE_ORDER_SHORT && this.modelOrder?.is_split_delivery !== Constants.IS_TRUE)) {
                            if (this.modelOrder?.type === Constants.ORDER_TYPE_QUOTE_SHORT && address.is_warehouse_collection != Constants.IS_WAREHOUSE_COLLECTION_YES) this.modelOrder.quote_summary.shipping_rate = detail.shipping_rate;
                            this.updateOrderSummary(this.modelOrder.id);
                        }
                        detail.shipping_truck_type_id = model.shipping_truck_type_id;
                        detail.address = address;
                        resolve(detail);
                    } else {
                        resolve(false);
                    }
                },
                () => resolve(false)
            );
        });
    }

    async getShippingCost(): Promise<unknown> {
        return new Promise((resolve) => {
            let model: any = {};

            if (this.modelOrder.quote_address?.[0]?.address_line_1 && this.modelOrder.quote_address?.[0]?.address_line_1.trim() !== '') {
                model.post_code = Number(this.modelOrder.quote_address?.[0]?.post_code);
                model.suburb = this.modelOrder.quote_address?.[0]?.suburb;

                // if (this.modelOrder.this.modelOrder.quote_address?.[0]?.shipping_truck_type_id) {
                //   model.shipping_truck_type_id = this.modelOrder.this.modelOrder.quote_address?.[0]?.shipping_truck_type_id;
                // }

                let products: any[] = [];
                if (this.modelOrder?.quote_product?.length > 0) {
                    this.modelOrder.quote_product.forEach((element: any) => {
                        products.push({
                            product_id: element.product_id,
                            price: element.price,
                            quantity: Number(element.quantity),
                        });
                    });
                }
                model.products = products;

                this.orderService.getShippingCost(model).subscribe(
                    (detail: any) => {
                        if (detail) {
                            this.modelOrder.quote_summary.shipping_rate = detail.shipping_rate;
                            this.modelOrder.quote_address[0].in_shipping_zone = detail.in_shipping_zone;
                            this.modelOrder.no_of_pallet = detail.no_of_pallet;
                            this.modelOrder.shipping_zone = detail.shipping_zone;

                            if (this.modelOrder.in_shipping_zone === Constants.IN_SHIPPING_ZONE_YES) {
                                this.modelOrder.is_manual_shipping_rate_change = null;
                                this.isManualShippingRateChange = false;
                            } else {
                                this.isManualShippingRateChange = this.modelOrder.shipping_rate ? true : false;
                            }

                            if (this.modelOrder.is_warehouse_collection === Constants.IS_WAREHOUSE_COLLECTION_YES) {
                                this.modelOrder.shipping_rate = 0;
                                this.modelOrder.is_manual_shipping_rate_change = null;
                                this.modelOrder.in_shipping_zone = Constants.IN_SHIPPING_ZONE_NO;
                                this.modelOrder.shipping_zone = null;
                            }

                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    },
                    () => resolve(false)
                );
            } else {
                resolve(true);
            }
        });
    }

    updateQuoteAddress(data: any) {
        return new Promise(async (resolve, reject) => {
            const addressPayload = {
                in_shipping_zone: data.address?.is_warehouse_collection ? Constants.IN_SHIPPING_ZONE_NO : data.in_shipping_zone,
                shipping_zone: data.address?.is_warehouse_collection ? null : data.shipping_zone,
                shipping_truck_type_id: data.shipping_truck_type_id,
            }
            this.quoteService.createOrUpdateQuoteDeliveryAddress(addressPayload, data.address?.id).subscribe({
                next: () => {
                    resolve(true);
                },
                error: () => {
                    resolve(false);
                }
            });
        });
    }

    updateQuoteQuantity(json: any, id: any, ifError: any = null) {
        return new Promise(async (resolve, reject) => {
            this.quoteService.updateQuoteProduct(json, id).subscribe(async (data: any) => {
                if (ifError == null) {
                    this.alertService.success(Constants.QUOTE_QUANTITY_UPDATED)
                    this.changeDetection.detectChanges();
                    this.modelOrder.final_total = data.final_total;
                }
                /*
                 * An assembled line's component allocation follows the new quantity — see
                 * followAssembledQuantityChange. Awaited, so the split-production call that follows
                 * on an order recomputes the line's stage from where the line has actually ended up.
                 */
                await this.followAssembledQuantityChange(id);
                resolve(true);
            }, (error: HttpErrorResponse) => {
                this.isLoading = false
                // Say why, and put the saved quantity back on screen: a refused quantity (e.g. a
                // consumable at 0 or over 9,999) otherwise stayed in the box as if it had saved.
                // 422s never reach the global error toast, so nothing else reports them.
                this.helperFunction.handleMultipleErrors(error);
                this.getOrderEvent.emit(false);
                reject(false);
            })
        });
    }

    /**
     * Brings an assembled line's component allocation into step with the quantity just saved.
     *
     * A decrease is trimmed, releasing stock the line no longer needs. An increase on a line that
     * was allocated in full is topped up from the sources it already draws on, or, when they cannot
     * cover the extra, the whole line moves to Unassigned and Stock Allocation Required is raised,
     * the way an ordinary product's quantity change does (decided 2026-10-01, ClickUp 86d49wbtt).
     * The extra used to be left as a separate Unassigned Stock entry, however much stock the source
     * had.
     *
     * Only the move to Unassigned is announced: the admin changed a quantity, not the allocation.
     * A failure is not surfaced either — the panel shows the line's real allocation regardless.
     */
    private async followAssembledQuantityChange(quoteProductId: any): Promise<void> {
        const line = (this.modelOrder?.quote_product ?? []).find((p: any) => p?.id === quoteProductId);
        if (!line?.product?.is_assembled_product) {
            return;
        }
        try {
            const result: any = await firstValueFrom(this.stockAllocationService.applyComponentQuantityChange(quoteProductId));
            if (result?.action === 'released') {
                this.alertService.info(Constants.ASSEMBLED_LINE_RELEASED_AFTER_QUANTITY_INCREASE);
            }
            if (line.componentAllocation) {
                this.loadComponentBoards(line);
            }
        } catch (_e) {
            /* left visible in the panel rather than hidden behind an alert */
        }
    }

    getConsumableCalculators(productId: any, qunatity: any, isDisplayLoader: boolean = false) {
        return new Promise((resolve, reject) => {
            let model = {
                product_id: productId,
                quantity: qunatity,
            };
            this.productService.getConsumableCalculators(model).subscribe((dataList: any) => {
                if (dataList) {
                    const currentProductIndex = this.modelOrder.quote_product.findIndex((x: any) => x?.product?.id == productId);
                    if (currentProductIndex >= 0) {
                        let oldCalculators = this.modelOrder.quote_product[currentProductIndex].quoteProductCalculators;
                        this.reAssignConsumableCalculators(oldCalculators, dataList, currentProductIndex);
                    }
                    resolve(true);
                } else {
                    reject(false);
                }
            }, () => {
                reject(false);
            });
        });
    }

    async updateQuoteProductAppliedCalculator(isDisplayFlashMessage: boolean = true, selectedProductId = null) {
        if (!this.modelOrder.quote_product?.length) {
            return false;
        }
        const tasks: any = [];

        this.modelOrder.quote_product
            .filter((product: any) => {
                // ❗ Exclude product if selectedProductId is passed
                if (selectedProductId !== null) {
                    return product.id !== selectedProductId;
                }
                return true;
            })
            .forEach((product: any) => {
                product.quoteProductCalculators?.forEach((consumableCalculator: any) => {

                    // ADD FLOW
                    if (consumableCalculator.is_selected === true) {
                        const form = {
                            quote_product_id: product.id,
                            type: consumableCalculator.type,
                            total_unit: consumableCalculator.total_unit,
                            total_price: consumableCalculator.total_price,
                        };

                        const obs$ = this.orderService.saveQuoteProductAppliedCalculator(form).pipe(
                            tap((quoteProductAppliedCalculatorModel: any) => {
                                consumableCalculator.id = quoteProductAppliedCalculatorModel;
                                this.changeDetection.detectChanges();

                                if (isDisplayFlashMessage) {
                                    this.alertService.success(
                                        this.isQuoteDetail
                                            ? Constants.CONSUMABLE_CALCULATOR_CONSTANTS.ADDED_TO_QUOTE_SUCCESS_MESSAGE
                                            : Constants.CONSUMABLE_CALCULATOR_CONSTANTS.ADDED_TO_ORDER_SUCCESS_MESSAGE
                                    );
                                }
                            })
                        );

                        tasks.push(obs$);
                    }

                    // REMOVE FLOW
                    else if (consumableCalculator.is_selected === false && consumableCalculator.id > 0) {
                        const obs$ = this.orderService.deleteQuoteProductAppliedCalculator(consumableCalculator.id).pipe(
                            tap(() => {
                                delete consumableCalculator.id;
                                this.changeDetection.detectChanges();

                                if (isDisplayFlashMessage) {
                                    this.alertService.success(
                                        this.isQuoteDetail
                                            ? Constants.CONSUMABLE_CALCULATOR_CONSTANTS.REMOVED_FROM_QUOTE_SUCCESS_MESSAGE
                                            : Constants.CONSUMABLE_CALCULATOR_CONSTANTS.REMOVED_FROM_ORDER_SUCCESS_MESSAGE
                                    );
                                }
                            })
                        );

                        tasks.push(obs$);
                    }
                });
            });

        if (tasks.length === 0) {
            return true;
        }

        try {
            await firstValueFrom(forkJoin(tasks));
            return true;
        } catch (err) {
            return false;
        }
    }

    toggleTotalPremiumAndAdhesiveCalculator() {
        toggleTotalPremiumAndAdhesiveCalculator(this.modelOrder, this.constants);
        this.changeDetection.detectChanges();
    }

    updateStatusOnAddressOrProductChange(convertDraftToQuote = false) {
        return new Promise((resolve, reject) => {
            let requestData: any = {
                id: this.modelOrder.id
            };
            if (convertDraftToQuote) {
                requestData.convert_draft_to_quote = convertDraftToQuote;
            }
            this.orderService.updateStatusOnAddressOrProductChange(requestData).subscribe((detail: any) => {
                resolve(true);
            }, (error: any) => {
                reject(false);
            });
        });
    }

    updateOrderSummary(createdQuoteId: any, resetAppliedCredit?: boolean, isManualShippingRequiredReset?: boolean): Promise<boolean> {
        if (createdQuoteId > 0) {
            return new Promise((resolve, reject) => {
                let json: any = {
                    quote_id: createdQuoteId,
                    applied_credit: this.modelOrder.quote_summary.applied_credit,
                    shipping_rate: this.modelOrder.quote_summary.shipping_rate,
                };
                if (resetAppliedCredit) {
                    json.is_applied_credit_reset = true;
                    json.applied_credit = 0;
                    this.modelOrder.quote_summary.applied_credit = 0;
                }
                if (isManualShippingRequiredReset) {
                    json.is_manual_shipping_rate_change = false;
                    json.shipping_rate = 0;
                }
                this.quoteService.updateQuoteSummary(json, this.modelOrder.quote_summary.id).subscribe(() => {
                    resolve(true);
                }, () => {
                    this.isLoading = false;
                    reject(false);
                });
            });
        }
        return Promise.resolve(false);
    }

    syncDeliveryWithUnleashed(): Promise<boolean> {
        if (this.modelOrder.id > 0) {
            return new Promise((resolve, reject) => {
                this.quoteService.syncDeliveryWithUnleashed(null, this.modelOrder.id).subscribe(() => {
                    resolve(true);
                }, () => {
                    this.isLoading = false;
                    reject(false);
                });
            });
        }
        return Promise.resolve(false);
    }

    syncProductWithUnleashed(): Promise<boolean> {
        if (this.modelOrder.id > 0) {
            this.isSyncingWithUnleashed = true;
            return new Promise((resolve, reject) => {
                this.quoteService.syncProductWithUnleashed(null, this.modelOrder.id).subscribe(() => {
                    this.isSyncingWithUnleashed = false;
                    this.changeDetection.detectChanges();
                    resolve(true);
                }, () => {
                    this.isSyncingWithUnleashed = false;
                    this.isLoading = false;
                    this.changeDetection.detectChanges();
                    reject(false);
                });
            });
        }
        return Promise.resolve(false);
    }

    syncAdditionalDeliveryDetailWithUnleashed(): Promise<boolean> {
        if (this.modelOrder.id > 0) {
            return new Promise((resolve, reject) => {
                this.quoteService.syncAdditionalDeliveryWithUnleashed(null, this.modelOrder.id).subscribe(() => {
                    resolve(true);
                }, () => {
                    this.isLoading = false;
                    reject(false);
                });
            });
        }
        return Promise.resolve(false);
    }

    calculateConsumableSummary() {
        this.consumableSummary = calculateConsumableSummary(this.modelOrder.quote_product, Constants.CONSUMABLE_CALCULATOR_TYPE_DEFENDER, Constants.CONSUMABLE_CALCULATOR_TYPE_GOLD)
        this.changeDetection.detectChanges();
    }

    reAssignConsumableCalculators(oldCalculators: any, newCalculators: any, currentProductIndex: any) {
        if (oldCalculators && oldCalculators.length > 0 && newCalculators && newCalculators.length > 0) {
            oldCalculators?.map((consumableCalculator: any, consumableCalculatorIndex: any) => {
                newCalculators[consumableCalculatorIndex].is_selected = consumableCalculator.is_selected;
                newCalculators[consumableCalculatorIndex].id = consumableCalculator.id;
            });
        }
        this.modelOrder.quote_product[currentProductIndex].quoteProductCalculators = newCalculators;
    }

    /**
     * Unit noun for a standalone consumable line — the adhesive is bagged, the sealers are bottled.
     *
     * A consumable line carries no product, so it has no unit_of_measurement to read and the Unit
     * cell rendered blank. Mirrors the same helper on the quote create/clone screens.
     */
    consumableUnitLabel(productsRow: any): string {
        return productsRow?.consumables_prices?.type === Constants.CONSUMABLE_QUANTITY_TYPE_LATICRETE_ADHESIVE
            ? 'Bags'
            : 'Bottles';
    }

    /**
     * A standalone consumable line at 1 has its minus switched off: 1 is the minimum, and pressing
     * it sent 0, which the API refuses. The delete button removes the line. Product lines are
     * unaffected.
     */
    isConsumableMinusDisabled(productsRow: any): boolean {
        return !!productsRow?.consumable_id && !productsRow?.product_id
            && isConsumableQuantityAtMinimum(productsRow?.quantity);
    }

    productImage(productData: any) {
        let imageUrl: any;
        if (
            (productData?.product?.type == Constants.SURFACE_SORT_NAME ||
                productData?.product?.type ==
                Constants.PRODUCT_TYPE_SURFACE_ACCESSORY) &&
            productData?.product?.product_image
        ) {
            imageUrl = productData.product.product_image[0];
            return imageUrl?.path
                ? Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL +
                '/' +
                imageUrl.path +
                Constants.IMAGE_SIZE_62_X_62
                : '';
        } else if (
            (productData?.product?.type == Constants.DECOR_SORT_NAME ||
                productData?.product?.type == Constants.PRODUCT_TYPE_DECOR_ACCESSORY) &&
            productData?.product?.product_image
        ) {
            imageUrl = productData?.product?.product_image[0];
            return imageUrl?.path
                ? Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL +
                '/' +
                imageUrl.path +
                Constants.IMAGE_SIZE_62_X_62
                : '';
        } else if (productData?.consumables_prices) {
            if (productData?.consumables_prices?.type === Constants.CONSUMABLE_QUANTITY_TYPE_LATICRETE_ADHESIVE) {
                return Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL +
                    '/ASSETS/PRODUCT/CONSUMABLE_PRODUCT/adhesive.png' +
                    Constants.IMAGE_SIZE_62_X_62;
            }
            if (productData?.consumables_prices?.type === Constants.CONSUMABLE_QUANTITY_TYPE_DEFENDER || productData?.consumables_prices?.type === Constants.CONSUMABLE_QUANTITY_TYPE_GOLD) {
                return Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL +
                    '/ASSETS/PRODUCT/CONSUMABLE_PRODUCT/sealer.png' +
                    Constants.IMAGE_SIZE_62_X_62;
            }
        }
        if (productData?.product?.product_image?.length) {
            imageUrl = productData.product.product_image[0];
            return imageUrl?.path
                ? Constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL + '/' + imageUrl.path + Constants.IMAGE_SIZE_62_X_62
                : Constants.NO_IMAGE_PRODUCT;
        }
        return Constants.NO_IMAGE_PRODUCT;
    }


    formatDimension(productDimension: any) {
        return productDimension ? productDimension.replace('mm', '') : '';
    }

    getCommentTooltip(comment: any): string {
        const htmlRegex = /<[^>]*>/g;
        let tempComment = comment ? comment.replace(htmlRegex, '').trim() : '';
        if (!tempComment) {
            return 'No comment added';
        }
        return comment ? comment : 'No comment added';
    }

    toggleStockIcon(productsRow) {
        // Assembled Products: load the component breakdown when the stock row is opened.
        if (productsRow?.product?.is_assembled_product && productsRow?.product_id) {
            this.loadAssembledInfo(productsRow.product_id, [productsRow]);
            // The expansion shows the component card sets, so load them with it.
            if (!productsRow.isStockExpanded) {
                this.loadComponentBoards(productsRow);
            }
        }
        productsRow.isStockExpanded = !productsRow.isStockExpanded;
        this.debugLogger.log('📦 Stock section toggled for product', productsRow.id, '- isStockExpanded:', productsRow.isStockExpanded);
    }




    openRevertSplitModal(productsRow: any): void {
        const instance = this.modalService1.open(RevertSplitModalComponent, {
            centered: true,
            backdrop: 'static',
            windowClass: 'revert-split-modal',
        });
        instance.componentInstance.quoteId = this.modelOrder?.id;
        instance.componentInstance.productId = productsRow.product_id;
        instance.componentInstance.childId = productsRow.id;
        instance.componentInstance.uom = productsRow?.product?.unit_of_measurement?.name ?? 'SQM';
        instance.componentInstance.productName = productsRow?.product?.family?.name || productsRow?.product?.sku || '';
        instance.result.then((result) => {
            if (result) {
                // "Split merged." said nothing about WHAT merged into what. With several split lines
                // on one product the admin could not tell which merge had just happened, or confirm
                // it was the one they intended. Name both lines, how much moved and the new total.
                this.alertService.success(this.buildMergeSuccessMessage(result, productsRow));
                // Both: getOrderEvent refreshes this table, triggerQuote reaches the stock panels
                // (and any other open view of the order) so no stale quantity is left on screen.
                this.getOrderEvent.emit(false);
                this.subscribersService.triggerQuote();
            }
        }).catch(() => {});
    }

    /**
     * "BORDEAUX: merged 3.84 m² from line 1.3 into line 1.1, which now has 6.72 m²."
     *
     * Degrades a piece at a time — if the modal could not report the quantities, the line numbers
     * alone are still worth saying; if it could not report those either, fall back to the old text.
     */
    private buildMergeSuccessMessage(outcome: any, productsRow: any): string {
        const product = productsRow?.product?.family?.name || productsRow?.product?.sku || '';
        const prefix = product ? `${product}: merged` : 'Merged';
        const unit = outcome?.unit ? ` ${outcome.unit}` : '';

        if (!outcome?.sourceLabel || !outcome?.targetLabel) return 'Split merged.';

        const moved = outcome.movedQty != null ? `${outcome.movedQty}${unit} from ` : '';
        const total = outcome.mergedQty != null
            ? `, which now has ${outcome.mergedQty}${unit}.`
            : '.';

        return `${prefix} ${moved}line ${outcome.sourceLabel} into line ${outcome.targetLabel}${total}`;
    }

    toggleStatusIcon(productsRow) {
        productsRow.isStatusExpanded = !productsRow.isStatusExpanded;
    }

    toggleCommentIcon(productsRow) {
        productsRow.isCommentExpanded = !productsRow.isCommentExpanded;
        if (!this.isQuillEditorInitialized) {
            this.initializeQuillEditor();
            this.isQuillEditorInitialized = true;
        }
    }

    /**
     * Handle product-level task completion click
     * Emits event to parent component (order-detail) to handle task completion
     */
    onProductTaskClick(task: any, product: any) {
        this.taskCompletionEvent.emit({
            taskId: task.id,
            assignedTo: task.assigned_to,
            taskCategoryId: task.task_category_id,
            task: task,
            product: product
        });
    }

    /**
     * Toggle tasks expand/collapse for a product
     */
    toggleTasksIcon(productsRow: any) {
        productsRow.isTasksExpanded = !productsRow.isTasksExpanded;
        this.debugLogger.log('📋 Tasks section toggled for product', productsRow.id, '- isTasksExpanded:', productsRow.isTasksExpanded);
    }

    /**
     * ✅ TrackBy function to prevent Angular from destroying/recreating DOM elements
     * This is CRITICAL for preserving Quill editors during data updates
     */
    trackByProductId(index: number, product: any): number {
        return product.id; // Use product ID as unique identifier
    }

    /**
     * ✅ Update existing Quill editors with new comment content after data refresh
     * This ensures that when socket events update the data, the Quill editors show the new content
     */
    updateQuillEditorsContent(): void {
        this.debugLogger.log('🔄 Child: updateQuillEditorsContent called');

        if (!this.modelOrder?.quote_product) {
            this.debugLogger.log('⚠️ Child: No quote_product found');
            return;
        }

        if (!this.quillEditorContainers) {
            this.debugLogger.log('⚠️ Child: No quillEditorContainers found');
            return;
        }

        this.debugLogger.log('📊 Child: Available Quill editors:', Object.keys(this.quillEditorContainers));
        this.debugLogger.log('📊 Child: Products to update:', this.modelOrder.quote_product.map(p => p.id));

        this.modelOrder.quote_product.forEach((product: any) => {
            // Find the Quill editor for this product using product ID as key
            const quillEditor = this.quillEditorContainers[product.id];

            if (!quillEditor) {
                this.debugLogger.log(`⚠️ Child: No Quill editor found for product ${product.id}`);
                return;
            }

            // Get current content to compare
            const currentContent = quillEditor.root.innerHTML;
            const newContent = product.note || '';

            // Only update if content has changed to avoid unnecessary updates
            if (currentContent !== newContent) {
                this.debugLogger.log(`📝 Child: Updating Quill editor content for product ${product.id} - Old: "${currentContent.substring(0, 50)}..." New: "${newContent.substring(0, 50)}..."`);

                // Update the editor content
                if (newContent) {
                    quillEditor.setContents(
                        quillEditor.clipboard.convert({ html: newContent })
                    );

                    // Update selected users for mentions
                    const editorContent = this.getContentWithMentions(product.id);
                    this.updateSelectedUsers(editorContent, product.id, true);
                } else {
                    // ✅ Clear the editor if note is empty - use setContents with empty delta
                    this.debugLogger.log(`📝 Child: Clearing Quill editor for product ${product.id} - note is empty`);
                    quillEditor.setContents([{insert: '\n'}]);
                    quillEditor.root.innerHTML = '';

                    // ✅ Clear selected users for this product
                    if (this.selectedUsers && this.selectedUsers[product.id]) {
                        this.selectedUsers[product.id] = [];
                    }
                }
            } else {
                this.debugLogger.log(`✅ Child: Product ${product.id} content already up to date`);
            }
        });
    }

    /**
     * Preserve current toggle states for all products
     * @returns Map of product IDs to their toggle states
     */
    private preserveToggleStates(): Map<number, any> {
        const toggleStates = new Map<number, any>();

        if (this.modelOrder?.quote_product && Array.isArray(this.modelOrder.quote_product)) {
            this.modelOrder.quote_product.forEach((product: any) => {
                if (product.id) {
                    const states = {
                        isCommentExpanded: product.isCommentExpanded || false,
                        isStockExpanded: product.isStockExpanded || false,
                        isStatusExpanded: product.isStatusExpanded || false,
                        isTasksExpanded: product.isTasksExpanded || false
                    };
                    toggleStates.set(product.id, states);

                    // ✅ Always log to see what's being preserved
                    this.debugLogger.log(`📦 Preserving states for product ${product.id}:`, states);
                }
            });
        }

        this.debugLogger.log('🔒 Preserved toggle states for', toggleStates.size, 'products');
        return toggleStates;
    }

    /**
     * Restore toggle states for all products
     * @param toggleStates Map of product IDs to their toggle states
     */
    private restoreToggleStates(toggleStates: Map<number, any>): void {
        if (!toggleStates || toggleStates.size === 0) {
            this.debugLogger.log('⚠️ No toggle states to restore');
            return;
        }

        let restoredCount = 0;
        if (this.modelOrder?.quote_product && Array.isArray(this.modelOrder.quote_product)) {
            this.modelOrder.quote_product.forEach((product: any) => {
                if (product.id && toggleStates.has(product.id)) {
                    const savedStates = toggleStates.get(product.id);
                    product.isCommentExpanded = savedStates.isCommentExpanded;
                    product.isStockExpanded = savedStates.isStockExpanded;
                    product.isStatusExpanded = savedStates.isStatusExpanded;
                    product.isTasksExpanded = savedStates.isTasksExpanded;
                    restoredCount++;

                    // ✅ Always log to see what's being restored
                    this.debugLogger.log(`📦 Restored states for product ${product.id}:`, savedStates);
                }
            });
        }

        this.debugLogger.log('🔓 Restored toggle states for', restoredCount, 'products');
        this.hydrateExpandedAssembledPanels();
    }

    /**
     * Re-loads the allocation panel for any assembled row that is still expanded.
     *
     * A reload of the order replaces every quote_product object, so `isStockExpanded` comes back
     * (restoreToggleStates puts it back) but the panel's own state does not — it hung off the old
     * object. The row then shows its stock icon lit with nothing beneath it, which is what merging a
     * split child left behind.
     *
     * Re-fetching here rather than suppressing the reload is the right way round: reloads are
     * necessary when the order's SHAPE changes — a split adds a line, a merge removes one — and
     * those changes have to appear.
     */
    private hydrateExpandedAssembledPanels(): void {
        (this.modelOrder?.quote_product ?? []).forEach((product: any) => {
            /*
             * Guarded on the state OBJECT, not on `detail`: loadComponentBoards() creates it
             * synchronously, so a load already in flight is not started again. `detail` is still
             * null while that request is out.
             */
            if (product?.isStockExpanded
                && product?.product?.is_assembled_product
                && !product?.componentAllocation) {
                this.loadComponentBoards(product);
            }
        });
    }

    /**
     * Debug method to test toggle state preservation manually
     * Call this from browser console: window.componentRef.testTogglePreservation()
     */
    public testTogglePreservation(): void {
        this.debugLogger.log('🧪 Testing toggle state preservation...');

        // Show current states
        this.debugLogger.log('Current toggle states:');
        this.modelOrder?.quote_product?.forEach((product: any, index: number) => {
            this.debugLogger.log(`Product ${product.id}: Comment=${product.isCommentExpanded}, Stock=${product.isStockExpanded}, Status=${product.isStatusExpanded}, Tasks=${product.isTasksExpanded}`);
        });

        // Simulate data refresh
        const toggleStates = this.preserveToggleStates();

        // Simulate sorting (which happens during socket updates)
        this.modelOrder.quote_product = this.sortQuoteProducts([...this.modelOrder.quote_product]);

        // Restore states
        this.restoreToggleStates(toggleStates);

        // Show final states
        this.debugLogger.log('States after preservation test:');
        this.modelOrder?.quote_product?.forEach((product: any, index: number) => {
            this.debugLogger.log(`Product ${product.id}: Comment=${product.isCommentExpanded}, Stock=${product.isStockExpanded}, Status=${product.isStatusExpanded}, Tasks=${product.isTasksExpanded}`);
        });

        this.changeDetection.detectChanges();
        this.debugLogger.log('✅ Toggle preservation test completed');
    }

    /**
     * Debug method to simulate socket data refresh
     * Call this from browser console: window.componentRef.simulateSocketRefresh()
     */
    public simulateSocketRefresh(): void {
        this.debugLogger.log('🔄 Simulating socket data refresh...');

        // Show current states
        this.debugLogger.log('Current toggle states before socket refresh:');
        this.modelOrder?.quote_product?.forEach((product: any, index: number) => {
            this.debugLogger.log(`Product ${product.id}: Comment=${product.isCommentExpanded}, Stock=${product.isStockExpanded}, Status=${product.isStatusExpanded}, Tasks=${product.isTasksExpanded}`);
        });

        // Emit the getOrderEvent which triggers parent refresh
        this.debugLogger.log('📡 Emitting getOrderEvent to trigger parent refresh...');
        this.getOrderEvent.emit(false);

        // The parent component should now preserve and restore toggle states
        setTimeout(() => {
            this.debugLogger.log('States after socket refresh simulation:');
            this.modelOrder?.quote_product?.forEach((product: any, index: number) => {
                this.debugLogger.log(`Product ${product.id}: Comment=${product.isCommentExpanded}, Stock=${product.isStockExpanded}, Status=${product.isStatusExpanded}, Tasks=${product.isTasksExpanded}`);
            });
            this.debugLogger.log('✅ Socket refresh simulation completed');
        }, 1000);
    }

    /**
     * Quick method to expand stock section for first product (for testing)
     * Call this from browser console: window.componentRef.expandFirstStock()
     */
    public expandFirstStock(): void {
        if (this.modelOrder?.quote_product && this.modelOrder.quote_product.length > 0) {
            const firstProduct = this.modelOrder.quote_product[0];
            firstProduct.isStockExpanded = true;
            this.debugLogger.log(`📦 Expanded stock section for product ${firstProduct.id}`);
            this.changeDetection.detectChanges();
        } else {
            this.debugLogger.log('❌ No products found to expand stock section');
        }
    }

    copySku(sku: string) {
        if (sku) {
            const selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            selBox.value = sku;

            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            document.execCommand('copy');
            document.body.removeChild(selBox);

            this.alertService.success(Constants.SKU_COPIED);
        }
    }

    checkDecimalDot(e: any) {
        var charCode = (e.which) ? e.which : e.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;
    }

    /**
     * The quote_product row a price/discount edit must be written to.
     *
     * A product line is looked up by product id, because the row handed to the popover can be a
     * different object from the one held in modelOrder.quote_product. A standalone consumable line
     * has no product to look up by — and its row IS the model object — so it is returned as-is.
     *
     * Every write below used to be gated on `product.id > 0`, so on a consumable line the discount
     * was calculated correctly and then silently thrown away: the popover accepted a percentage and
     * nothing changed. Consumables carry their price on the line itself (quote_product.price), so
     * the surrounding arithmetic already works for them — only the write was missing.
     */
    private resolveDiscountTargetLine(productDetail: any): any {
        if (productDetail?.consumable_id && !productDetail?.product_id) return productDetail;
        const productId = productDetail?.product?.id;
        if (!productId || productId <= 0) return null;
        return (this.modelOrder?.quote_product ?? []).find((x: any) => x?.product?.id == productId) ?? null;
    }

    onPopoverHidden(productDetail: any) {
        var discountedPrice: any = (Number(productDetail.price) - (productDetail.price * productDetail.discount / 100)).toFixed(4)
        productDetail.updated_sku_price = discountedPrice;
        productDetail.applied_discount = productDetail.discount;
    }

    closePopOver(pop: any, is_update: any = false, productDetail: any) {
        if (this.modelOrder?.quote_product && !is_update) {
            this.modelOrder?.quote_product.forEach((element: any) => {

                let otherModel: any = element;
                var discountedPrice: any = (Number(element.price) - (element.price * element.discount / 100)).toFixed(4)
                otherModel.updated_sku_price = discountedPrice;
                otherModel.applied_discount = element.discount;

                element = otherModel;
            });
        }
        pop.close();
    }

    editProductDiscount(event: any, productDetail: any) {
        let discount = (event.target.value) ? event.target.value : 0;

        var productDiscountPrice = productDetail.price

        var discountedPrice: any = Number(productDiscountPrice);
        let is_discount = false;
        let discount_price = "0.00";

        if (discount <= 100) {
            discountedPrice = (productDiscountPrice - (productDiscountPrice * discount / 100)).toFixed(4);
            discount_price = (productDiscountPrice - discountedPrice).toFixed(4);

            if (discount == "" || discount == null) {
                is_discount = false;
            } else {
                is_discount = true;
            }

            const targetLine = this.resolveDiscountTargetLine(productDetail);
            if (targetLine) {
                targetLine.applied_discount = discount;
                targetLine.is_discount = is_discount;
                targetLine.updated_sku_price = discountedPrice;
                targetLine.applied_discount_price = discount_price;
            }
        } else {
            discountedPrice = Number(productDiscountPrice);
            this.alertService.error(Constants.PRODUCT_PERCENTAGE_GREATER_THAN_ERROR);
            const targetLine = this.resolveDiscountTargetLine(productDetail);
            if (targetLine) {
                targetLine.applied_discount = productDetail.discount;
                targetLine.is_discount = is_discount;
            }
        }
    }

    editProductPrice(event: any, productDetail: any) {
        let new_price = event.target.value;
        let old_price = productDetail.price

        let discount = '0.00';
        let is_discount = false;
        let discount_price = "0.00";

        new_price = new_price.replace(/-/g, '');
        new_price = Number((new_price) ? new_price : 0);

        if (new_price <= old_price && new_price >= 0) {
            discount = (((old_price - new_price) * 100) / old_price).toFixed(4);
            discount_price = (old_price - new_price).toFixed(4);

            if (new_price == "" || new_price == null) {
                is_discount = false;
            } else {
                is_discount = true;
            }
            const targetLine = this.resolveDiscountTargetLine(productDetail);
            if (targetLine) {
                targetLine.applied_discount = discount;
                targetLine.is_discount = is_discount;
                targetLine.updated_sku_price = new_price;
                targetLine.applied_discount_price = discount_price;
            }
        } else {
            if (new_price > 10000) {
                this.alertService.error(Constants.PRODUCT_PRICE_GREATER_THAN_ERROR);
            }
            const targetLine = this.resolveDiscountTargetLine(productDetail);
            if (targetLine) {
                targetLine.applied_discount = discount;
                targetLine.is_discount = is_discount;
                targetLine.applied_discount_price = discount_price;
            }
        }
    }

    private _hasPriceDiscountChanged(productDetail: any): boolean {
        const line = this.resolveDiscountTargetLine(productDetail);
        if (!line) return false;
        const currentDiscount = Number(line.discount || 0);
        const newDiscount = Number(productDetail.applied_discount || 0);
        const currentDiscountedPrice = Number(line.discounted_price || line.price);
        const newDiscountedPrice = Number(productDetail.updated_sku_price || line.price);
        return !(currentDiscount === newDiscount && Math.abs(currentDiscountedPrice - newDiscountedPrice) < 0.01);
    }

    async updateProductPriceDiscount(pop: any, productDetail: any) {
        if (this._hasPriceDiscountChanged(productDetail) && this.modelOrder.quote_summary?.applied_credit > 0 && this.modelOrder.type === Constants.ORDER_TYPE_QUOTE_SHORT) {
            this.modalRef = this.modalService.show(ConfirmModalComponent);
            this.modalRef.content.title = 'Confirm Price Update';
            this.modalRef.content.message = Constants.UPDATE_PRODUCT_QUANTITY_AFTER_CREDIT_APPLIED_MESSAGE(this.modelOrder?.type === Constants.ORDER_TYPE_ORDER_SHORT ? 'order' : 'quote');
            this.modalRef.setClass('delete-favourite-modal');
            this.modalRef.content.onClose.subscribe(async (result: any) => {
                if (result !== false && result !== undefined) {
                    await this._executePriceDiscountUpdate(pop, productDetail);
                }
            });
            return;
        }
        await this._executePriceDiscountUpdate(pop, productDetail);
    }

    async _executePriceDiscountUpdate(pop: any, productDetail: any) {
        this.closePopOver(pop, true, productDetail);

        const targetLine = this.resolveDiscountTargetLine(productDetail);
        if (targetLine) {
            var is_update = this._hasPriceDiscountChanged(productDetail);
            // Show all price on the page
            {
                {
                    targetLine.final_total = productDetail.updated_sku_price * productDetail.quantity;
                    let appliedDiscount = productDetail.applied_discount.toString();
                    appliedDiscount = appliedDiscount.replace(/^0+(?=\d)/, '');
                    if (appliedDiscount === '' || appliedDiscount.startsWith('.')) {
                        appliedDiscount = '0' + appliedDiscount;
                    }
                    if (appliedDiscount === '0') {
                        appliedDiscount = '0.00';
                    }
                    targetLine.discount = appliedDiscount;
                    targetLine.discounted_price = this.calculateDiscountedPrice(productDetail.price, productDetail?.applied_discount);
                    this.changeDetection.detectChanges()
                }
            }
            if (is_update) {
                this.isLoadingEvent.emit(true);

                // Exactly one identity goes on the wire — a consumable line has no product_id, and
                // sending a null one makes the API read it as a product line with no product.
                const isConsumableLine = !!productDetail?.consumable_id && !productDetail?.product_id;
                let json: any = {
                    // id: productDetail?.id,
                    is_price_update: true,
                    quantity: productDetail.quantity,
                    discount: productDetail?.applied_discount,
                    quote_id: productDetail?.quote_id,
                    ...(isConsumableLine
                        ? {consumable_id: productDetail.consumable_id}
                        : {product_id: productDetail?.product_id}),
                    discounted_price: this.calculateDiscountedPrice(productDetail.price, productDetail?.applied_discount),
                    price: productDetail.price,
                    ...(productDetail.includeWastage ? {wastage_percentage: productDetail.currentWastage} : {})
                }

                try {
                    if (this.modelOrder.applied_credit > 0) {
                        json.is_credit_reset = true;
                    }
                    await this.updateQuotePriceDiscount(json, productDetail?.id);
                    this.modelOrder.quote_summary.applied_credit = 0;

                    // await this.getConsumableCalculators(productDetail.product_id, productDetail.quantity, false);
                    // await this.updateQuoteProductAppliedCalculator(false);
                    // await this.updateOrderSummary(this.modelOrder.id);
                    // this.toggleTotalPremiumAndAdhesiveCalculator();
                    //
                    // if (this.modelOrder.type === Constants.ORDER_TYPE_ORDER_SHORT && !this.isOfflineOrder) {
                    //     await this.syncProductWithUnleashed();
                    // }
                    //
                    // const requestParamContestModel = new RequestParamModel();
                    // requestParamContestModel.expands = ['quoteOverallSealerUnit'];
                    // delete requestParamContestModel.pageSize;
                    // await this.quoteService.getQuoteDetail(this.modelOrder.id, requestParamContestModel).subscribe((dataList: QuoteOrderSampleModel) => {
                    //     this.modelOrder.subtotal = dataList.subtotal;
                    //     this.modelOrder.shipping_rate = dataList.shipping_rate;
                    //     this.modelOrder.tax_gst = dataList.tax_gst;
                    //     this.modelOrder.applied_credit = dataList.applied_credit;
                    //     this.modelOrder.final_total = dataList.final_total;
                    //     this.modelOrder.no_of_pallet = dataList.no_of_pallet;
                    //     this.modelOrder.quoteOverallSealerUnit = dataList.quoteOverallSealerUnit;
                    // });

                    // Recalculate consumable summary
                    this.calculateConsumableSummary();
                    this.getOrderEvent.emit(false);
                } catch (error) {
                    console.error("Error updating price discount:", error);
                    this.isLoadingEvent.emit(false);
                } finally {
                    this.isLoadingEvent.emit(false);
                }
            }
        }
        this.changeDetection.detectChanges();
    }

    calculateDiscountedPrice(price, applied_discount) {
        const itemPrice = this.safeValue(price);
        const appliedDiscount = this.safeValue(applied_discount);
        const discountedPrice = +(itemPrice - (itemPrice * appliedDiscount) / 100).toFixed(4);

        this.modelOrder.quote_product.discountedPrice = discountedPrice.toFixed(4);
        return discountedPrice.toFixed(4);
    }

    safeValue = (value, defaultValue = 0) => value != null ? value : defaultValue;

    updateQuotePriceDiscount(json: any, id, ifError: any = null) {
        return new Promise(async (resolve, reject) => {
            this.quoteService.updateQuoteProduct(json, id).subscribe(data => {
                if (ifError == null) {
                    this.alertService.success(Constants.QUOTE_DISCOUNT_PRICE_UPDATED)
                }
                resolve(true);
            }, () => {
                this.isLoading = false
                reject(false);
            })
        });
    }

    openPopover(popover: any, status: any) {
        if (this.isOrderCancel) {
            return false;
        }

        if (this.modelOrder?.is_archive && this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES) {
            this.alertService.error(this.isOrderDetail ? Constants.UNABLE_ORDER_DETAIL_CHANGE : Constants.UNABLE_QUOTE_DETAIL_CHANGE);
            return false;
        }

        if (this.modelOrder?.is_expired && this.modelOrder?.is_expired === Constants.QUOTE_IS_EXPIRED_YES) {
            this.alertService.error(Constants.UNABLE_QUOTE_STATUS_CHANGE_WITH_EXPIRED);
            return false;
        }

        if (this.modelOrder?.status?.short_name === Constants.ORDER_DELIVERD_SHORT || this.modelOrder?.status?.short_name === Constants.ORDER_FOLLOW_UP_SHORT || status?.short_name === Constants.ORDER_DELIVERD_SHORT) {
            this.alertService.error(Constants.UNABLE_DELIVERED_QUOTE_PRODUCT_CHANGE);
            return;
        }
        if (this.modelOrder?.status?.short_name === Constants.ORDER_COMPLETED_SHORT) {
            this.alertService.error(Constants.UNABLE_COMPLETED_QUOTE_PRODUCT_CHANGE);
            return;
        }

        if (this.modelOrder.applied_credit > 0) {
            this.modalRef = this.modalService.show(ConfirmModalComponent);
            this.modalRef.content.title = 'Confirm Price Update';
            this.modalRef.content.message = Constants.UPDATE_PRODUCT_DISCOUNT_AFTER_CREDIT_APPLIED.BODY_MESSAGE;
            this.modalRef.setClass('delete-favourite-modal');
            this.modalRef.content.onClose.subscribe((result: any) => {
                if (result !== false && result !== undefined) {
                    popover.open();
                }
            });
        } else {
            popover.open();
        }
    }

    removeProduct(product: any) {
        if (this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES) {
            this.alertService.error(this.isOrderDetail ? Constants.UNABLE_ORDER_DETAIL_CHANGE : Constants.UNABLE_QUOTE_DETAIL_CHANGE);
            return false;
        }

        if (this.modelOrder?.is_expired === Constants.QUOTE_IS_EXPIRED_YES) {
            this.alertService.error(Constants.UNABLE_QUOTE_STATUS_CHANGE_WITH_EXPIRED);
            return false;
        }
        if (this.modelOrder?.status?.short_name === Constants.ORDER_DELIVERD_SHORT || this.modelOrder?.status?.short_name === Constants.ORDER_FOLLOW_UP_SHORT || product?.status_quote_product?.short_name === Constants.ORDER_DELIVERD_SHORT) {
            this.alertService.error(Constants.UNABLE_DELIVERED_QUOTE_PRODUCT_CHANGE);
            return;
        }
        if (this.modelOrder?.status?.short_name === Constants.ORDER_COMPLETED_SHORT) {
            this.alertService.error(Constants.UNABLE_COMPLETED_QUOTE_PRODUCT_CHANGE);
            return;
        }

        if (this.modelOrder.quote_product.length > 1) {
            const canDeleteProduct = (this.modelOrder.is_expired !== Constants.QUOTE_IS_EXPIRED_YES && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT && this.modelOrder?.quote_summary?.shipping_rate != null && this.modelOrder?.quote_summary?.shipping_rate >= 0 && this.isQuoteAccepted) || (this.modelOrder.is_expired !== Constants.QUOTE_IS_EXPIRED_YES && (this.modelOrder?.defaultQuoteAddress?.in_shipping_zone === Constants.IN_SHIPPING_ZONE_NO || this.modelOrder?.defaultQuoteAddress?.in_shipping_zone === Constants.IN_SHIPPING_ZONE_YES) && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT && this.modelOrder?.quote_summary?.shipping_rate != null && this.modelOrder?.quote_summary?.shipping_rate >= 0 && !this.isQuoteAccepted) || (this.modelOrder?.defaultQuoteAddress?.in_shipping_zone == null && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT && this.modelOrder?.status?.short_name !== Constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT && this.modelOrder?.quote_summary?.shipping_rate != null && this.modelOrder?.quote_summary?.shipping_rate === 0);

            const confirmationTitle = canDeleteProduct && this.modelOrder?.quote_summary?.applied_credit > 0 ? Constants.CONFIRMATION_CART_PRODUCT_DELETE_TITLE : Constants.CONFIRMATION_CART_PRODUCT_DELETE_TITLE;
            let confirmationMessage = this.isQuoteDetail ? Constants.DELETE_PRODUCT_FROM_QUOTE_CONSTANTS.BODY_MESSAGE : Constants.DELETE_PRODUCT_FROM_QUOTE_CONSTANTS.ORDER_BODY_MESSAGE;
            if (this.isDisabledQuoteDetail) {
                confirmationMessage = 'Are you sure you want delete this product?';
            }

            // Same exemption as the quantity path above: a consumables record has no manual
            // delivery fee, and `shipping_rate >= 0` is trivially true at $0.
            //
            // The two fee conditions are grouped so every guard applies to both. `&&` binds tighter
            // than `||`, so the "Other" truck branch used to sit outside the consumables and
            // can-delete guards and fired on every consumables-only record (truck type Other at $0).
            // A warehouse collection carries no delivery fee at all, matching the quantity paths.
            if (!this.isFreeDeliveryConsumablesRecord && canDeleteProduct
                && this.modelOrder?.defaultQuoteAddress?.is_warehouse_collection != Constants.IS_WAREHOUSE_COLLECTION_YES
                && (((this.modelOrder?.defaultQuoteAddress?.in_shipping_zone == Constants.IN_SHIPPING_ZONE_NO || this.modelOrder?.defaultQuoteAddress?.in_shipping_zone == Constants.IN_SHIPPING_ZONE_YES) && this.modelOrder?.quote_summary?.shipping_rate >= 0 && this.modelOrder?.quote_summary?.is_manual_shipping_rate_change == Constants.IS_MANUAL_SHIPPING_RATE_CHANGE_YES) || (this.modelOrder?.defaultQuoteAddress?.shipping_truck_type_id == Constants.OTHER_TRUCK_ID && this.modelOrder?.quote_summary?.shipping_rate >= 0))) {
                confirmationMessage = Constants.ADD_PRODUCT_TO_QUOTE_AFTER_DELIVERY_CHARGE_ADDED.BODY_MESSAGE;
            }

            if (canDeleteProduct && this.modelOrder?.quote_summary?.applied_credit > 0) {
                confirmationMessage = Constants.DELETE_PRODUCT_AFTER_CREDIT_APPLIED.BODY_MESSAGE;
            }

            this.modalRef = this.modalService.show(ConfirmModalComponent);
            this.modalRef.content.title = confirmationTitle;
            this.modalRef.content.message = confirmationMessage;
            this.modalRef.setClass('delete-favourite-modal');
            this.modalRef.content.onClose.subscribe((result: any) => {
                if (result) {
                    this.isLoadingEvent.emit(true);

                    let isResetCredit = false;
                    if (this.modelOrder?.quote_summary?.applied_credit > 0) {
                        isResetCredit = true;
                    }
                    let isManualShippingRequiredReset = false
                    if ((this.modelOrder?.quote_summary?.is_manual_shipping_rate_change == Constants.IS_MANUAL_SHIPPING_RATE_CHANGE_YES || (this.modelOrder?.defaultQuoteAddress?.in_shipping_zone == Constants.IN_SHIPPING_ZONE_NO && this.modelOrder?.quote_summary?.shipping_rate !== null && this.modelOrder?.quote_summary?.shipping_rate >= 0)) && this.modelOrder?.defaultQuoteAddress?.is_warehouse_collection == Constants.IS_WAREHOUSE_COLLECTION_NO) {
                        isManualShippingRequiredReset = true;
                    }

                    this.quoteService.deleteQuoteProduct(product.id)
                        .subscribe(async () => {
                            this.isAddRemoveProduct = true;
                            // await this.reCalculateConsumable();
                            // await this.updateQuoteProductAppliedCalculator();
                            /*if (this.modelOrder.type === Constants.ORDER_TYPE_ORDER) {
                              await this.updateStatusOnAddressOrProductChange();
                            }*/
                            // if (this.modelOrder.quote_product.length == 2 && this.modelOrder.is_split_delivery) {
                            //   await firstValueFrom(this.quoteService.updateQuote({id: this.modelOrder.id, is_split_delivery: false}));
                            //   await firstValueFrom(this.quoteService.splitDelivery(this.modelOrder.id));
                            // } else {
                            //   if (this.modelOrder.is_split_delivery && product?.quote_schedule_delivery_product?.quote_schedule_delivery_id) {
                            //     await this.updateQuoteScheduleDelivery(product.quote_schedule_delivery_product.quote_schedule_delivery_id);
                            //     this.subscribersService.trigger();
                            //   }
                            // }

                            // Call the split production API
                            if (this.modelOrder.type === Constants.ORDER_TYPE_ORDER_SHORT) {
                                await firstValueFrom(this.quoteService.splitProduction({id: this.modelOrder.id}));
                            }

                            // await this.updateOrderSummary(this.modelOrder.id, isResetCredit, isManualShippingRequiredReset);
                            // if (this.modelOrder.type === Constants.ORDER_TYPE_QUOTE_SHORT) {
                            //   await this.updateStatusOnAddressOrProductChange();
                            // }

                            // if (this.modelOrder.type === Constants.ORDER_TYPE_ORDER_SHORT && !this.isOfflineOrder) {
                            //   await this.syncDeliveryWithUnleashed();
                            //   await this.syncProductWithUnleashed();
                            //   await this.syncAdditionalDeliveryDetailWithUnleashed();
                            // }

                            this.changeDetection.detectChanges();
                            this.getOrderEvent.emit(false);

                            this.isLoadingEvent.emit(false);
                            this.alertService.success(Constants.QUOTE_ORDER_MESSAGE_CONSTANTS.PRODUCT_REMOVE);
                            this.changeDetection.detectChanges();
                        }, (error: any) => {
                            this.isLoadingEvent.emit(false);
                            if (error.message) {
                                this.alertService.error(error.message);
                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        } else {
            this.alertService.error(this.isOrderDetail ? Constants.QUOTE_ORDER_MESSAGE_CONSTANTS.ORDER_PRODUCT_RESTRICTION_FOR_LAST_PRODUCT : Constants.QUOTE_ORDER_MESSAGE_CONSTANTS.QUOTE_PRODUCT_RESTRICTION_FOR_LAST_PRODUCT)
        }
    }


    reCalculateConsumable() {
        return new Promise((resolve, reject) => {
            const consumables = [];
            this.modelOrder.quote_product.map(product => {
                if (product?.quoteProductCalculators?.length) {
                    // Check if any item has type 'defender' or 'gold'
                    let isTypeDefenderOrGold = product.quoteProductCalculators.some(item => (item.type === 'defender' || item.type === 'gold') && item.is_selected);
                    const formattedProduct: any = {
                        product_id: product.product.id,
                        quantity: +product.quantity,
                        is_calculate: isTypeDefenderOrGold
                    };

                    product.quoteProductCalculators.map(consumable => {
                        if (consumable.type === 'defender' || consumable.type === 'gold') {
                            formattedProduct[consumable.type] = {
                                total_unit: consumable.total_unit
                            };
                        }
                    });
                    consumables.push(formattedProduct);
                }
            });

            if (consumables?.length) {
                this.productService.reCalculateConsumable(consumables).subscribe((res) => {
                    if (res?.length) {
                        this.modelOrder.quote_product.map(product => {
                            res.map(item => {
                                if (item.product_id === product.product.id) {
                                    product.quoteProductCalculators.map(consumable => {
                                        if (item[consumable.type]) {
                                            consumable.total_price = item[consumable.type].total_price;
                                            consumable.discounted_price = item[consumable.type].total_price;
                                        }
                                    });
                                }
                            });
                        });
                    }
                    resolve(true)
                }, (error) => {
                    reject(error)
                })
            } else {
                resolve(true)
            }
        });
    }

    updateQuoteScheduleDelivery(scheduleDeliveryId, requestData: any = {}) {
        return new Promise((resolve, reject) => {
            requestData.is_split_delivery = true;
            this.quoteService.quoteScheduleDelivery(requestData, scheduleDeliveryId).subscribe(() => {
                resolve(true);
            }, () => {
                reject(false);
            });
        });
    }

    /**
     * Offline display mode for the consumable (adhesive/sealer) calculators: SO offline orders and
     * SQ offline quotes share the same calculation/columns, so both use the offline rendering.
     */
    get isOfflineConsumableDisplay(): boolean {
        return this.isOfflineOrder || this.isOfflineQuote;
    }

    calculatePrice(total_price?: number): number {
        if (!total_price || isNaN(total_price)) {
            return 0; // Return 0 if total_price is null, undefined, or not a number
        }
        const price = total_price;
        return parseFloat(price.toFixed(2)); // Convert to number with 2 decimal places
    }

    private showConfirmModal(title: string, message: string): Promise<boolean> {
        return new Promise((resolve) => {
            let modalRef = this.modalService.show(ConfirmModalComponent);
            modalRef.setClass('delete-favourite-modal');
            modalRef.content.title = title;
            modalRef.content.message = message;
            modalRef.content.onClose.subscribe((result: any) => {
                resolve(result);
            });
        });
    }

    async toggleProductCalculator(e: any, selectedProduct: any, calculatorIndex: any, selectedProductIndex: any, type: any = null) {
        if (this.modelOrder?.is_archive || this.modelOrder?.is_expired || this.isDisabledQuoteDetail || this.isOrderCancel) return;
        if (this.modelOrder.applied_credit > 0) {
            e.preventDefault();
            e.target.checked = !e.target.checked;
            const isChecked = e.target.checked;
            const title = isChecked ? 'Confirm Remove Consumable Calculation' : 'Confirm Add Consumable Calculation';
            const message = isChecked ? Constants.REMOVE_CONSUMABLE_CALCULATOR_AFTER_CREDIT_APPLIED.BODY_MESSAGE : Constants.ADD_CONSUMABLE_CALCULATOR_AFTER_CREDIT_APPLIED.BODY_MESSAGE;
            const confirmed = await this.showConfirmModal(title, message);
            if (!confirmed) return;
            else e.target.checked = !e.target.checked;
        }

        // ✅ START LOADER with unique operation ID to track concurrent toggles
        const operationId = `toggle-${selectedProduct.id}-${calculatorIndex}-${Date.now()}`;
        this.setLoadingState(operationId, true);

        try {
            let calculatorIndexes: any = [];
            if (selectedProduct) {
                calculatorIndexes.push(calculatorIndex);
                selectedProduct.quoteProductCalculators[calculatorIndex].is_selected = e.target.checked;

                // Link Defender and Gold types logic
                const defenderType = Constants.CONSUMABLE_CALCULATOR_TYPE_DEFENDER;
                const goldType = Constants.CONSUMABLE_CALCULATOR_TYPE_GOLD;

                if (selectedProduct.quoteProductCalculators[calculatorIndex].type == defenderType) {
                    const goldIndex = selectedProduct.quoteProductCalculators.findIndex((x: any) => x?.type == goldType);
                    if (goldIndex !== -1) {
                        calculatorIndexes.push(goldIndex);
                        selectedProduct.quoteProductCalculators[goldIndex].is_selected = e.target.checked;
                    }
                }
                if (selectedProduct.quoteProductCalculators[calculatorIndex].type == goldType) {
                    const defenderIndex = selectedProduct.quoteProductCalculators.findIndex((x: any) => x?.type == defenderType);
                    if (defenderIndex !== -1) {
                        calculatorIndexes.push(defenderIndex);
                        selectedProduct.quoteProductCalculators[defenderIndex].is_selected = e.target.checked;
                    }
                }
            }

            // Local Synchronous updates
            this.toggleTotalPremiumAndAdhesiveCalculator();
            this.calculateConsumableSummary();

            // 3. ASYNC PROCESSES
            // Save or Delete the specific calculators for the selected product
            // ✅ Phase 3: Backend returns ALL redistributed calculators - NO MORE RE-SAVES
            for (const idx of calculatorIndexes) {
                await this.applyProductCalculator(selectedProduct, idx);
            }

            // ✅ Phase 3: Removed updateQuoteProductAppliedCalculator() call
            // Backend now returns all affected calculators in single response (27x faster!)

            // Reset credit and update summary
            this.modelOrder.applied_credit = 0;
            await this.updateOrderSummary(this.modelOrder.id);

            // Sync with Unleashed if Order
            if (this.modelOrder.type === Constants.ORDER_TYPE_ORDER_SHORT && !this.isOfflineOrder) {
                await this.syncProductWithUnleashed();
            }

            // 4. Final state calculations
            let totalAppliedCalculatorPrice = 0;
            selectedProduct.quoteProductCalculators?.forEach((consumableCalculator: any) => {
                if (consumableCalculator.is_selected) {
                    totalAppliedCalculatorPrice = Number((totalAppliedCalculatorPrice + +consumableCalculator.total_price).toFixed(2));
                }
            });

            this.modelOrder.quote_product[selectedProductIndex].total_applied_calculator_price = totalAppliedCalculatorPrice;

            // Notify other components and trigger UI update
            this.getOrderEvent.emit(false);

        } catch (error) {
            console.error("Error in toggleProductCalculator:", error);
            // Error alerts are handled inside save/delete/update methods provided in your snippet
        } finally {
            // ✅ HIDE LOADER for this specific operation
            // This executes regardless of whether the try block succeeded or caught an error
            this.setLoadingState(operationId, false);
        }
    }

    async applyProductCalculator(selectedProduct: any, calculatorIndex: any): Promise<void> {
        const selectedCalculator = selectedProduct.quoteProductCalculators[calculatorIndex];
        if (selectedCalculator.is_selected) {
            await this.saveCalculator(selectedProduct, selectedCalculator);
        } else if (selectedCalculator.id) {
            await this.deleteCalculator(selectedCalculator);
        }
    }

    private saveCalculator(selectedProduct: any, selectedCalculator: any): Promise<void> {
        return new Promise((resolve, reject) => {
            const form: any = {
                quote_product_id: selectedProduct.id,
                type: selectedCalculator.type,
                total_unit: selectedCalculator.total_unit,
                total_price: selectedCalculator.total_price,
            };

            if (this.modelOrder.type === Constants.ORDER_TYPE_QUOTE_SHORT) {
                form.applied_credit = 0;
            }

            this.orderService.saveQuoteProductAppliedCalculator(form).subscribe({
                next: (res) => {
                    // ✅ Phase 3: Update UI with ALL affected calculators from backend response
                    if (res?.affected_calculators) {
                        this.updateUIWithAffectedCalculators(res.affected_calculators);
                    } else {
                        // Fallback for old response format (just ID)
                        selectedCalculator.id = res?.id || res;
                    }
                    this.changeDetection.detectChanges();
                    this.alertService.success(this.isQuoteDetail ? Constants.CONSUMABLE_CALCULATOR_CONSTANTS.ADDED_TO_QUOTE_SUCCESS_MESSAGE : Constants.CONSUMABLE_CALCULATOR_CONSTANTS.ADDED_TO_ORDER_SUCCESS_MESSAGE);
                    resolve();
                },
                error: (err) => {
                    this.alertService.error(this.isQuoteDetail ? Constants.CONSUMABLE_CALCULATOR_CONSTANTS.ADDED_TO_QUOTE_ERROR_MESSAGE : Constants.CONSUMABLE_CALCULATOR_CONSTANTS.ADDED_TO_ORDER_ERROR_MESSAGE);
                    reject(err);
                }
            });
        });
    }

    private deleteCalculator(selectedCalculator: any): Promise<void> {
        return new Promise((resolve, reject) => {
            this.orderService.deleteQuoteProductAppliedCalculator(selectedCalculator.id).subscribe({
                next: (res) => {
                    delete selectedCalculator.id;
                    // ✅ Phase 3: Update UI with remaining redistributed calculators
                    if (res?.affected_calculators) {
                        this.updateUIWithAffectedCalculators(res.affected_calculators);
                    }
                    this.alertService.success(this.isQuoteDetail ? Constants.CONSUMABLE_CALCULATOR_CONSTANTS.REMOVED_FROM_QUOTE_SUCCESS_MESSAGE : Constants.CONSUMABLE_CALCULATOR_CONSTANTS.REMOVED_FROM_ORDER_SUCCESS_MESSAGE);
                    resolve();
                },
                error: (err) => {
                    this.alertService.error(this.isQuoteDetail ? Constants.CONSUMABLE_CALCULATOR_CONSTANTS.REMOVED_FROM_QUOTE_ERROR_MESSAGE : Constants.CONSUMABLE_CALCULATOR_CONSTANTS.REMOVED_FROM_ORDER_ERROR_MESSAGE);
                    reject(err);
                }
            });
        });
    }

    updateQuoteOrder(isCreditReset = false, isReAppliedConsumable = false) {
        return new Promise((resolve, reject) => {
            let json: any = {
                id: this.modelOrder.id,
                shipping_rate: this.modelOrder.shipping_rate,
                deposit_amount: this.modelOrder.deposit_amount,
                final_due_amount: this.modelOrder.final_due_amount,
            }
            if (this.isManualShippingRateChange == true) {
                this.isManualShippingRateChange = false;
                json.is_manual_shipping_rate_change = null;
            }

            if (isReAppliedConsumable) {
                json.is_re_applied_consumable = true;
            }

            this.orderService.updateQuoteOrder(json).subscribe((data) => {
                if (data) {
                    resolve(true);
                    this.changeDetection.detectChanges();
                    this.updateOrderSummary(this.modelOrder.id);
                } else {
                    resolve(true);
                }
            }, (error: any) => {
                this.helperFunction.handleError(error);
                reject(false);
            })
        });
    }

    getQuoteOverallSealerUnit() {
        return new Promise((resolve, reject) => {
            const requestParamContestModel = new RequestParamModel();
            requestParamContestModel.fields = ['id', 'quoteOverallSealerUnit'];
            requestParamContestModel.expands = ['quoteOverallSealerUnit'];
            this.quoteService.getQuoteDetail(this.modelOrder.id, requestParamContestModel).subscribe((dataList: QuoteOrderSampleModel) => {
                if (dataList) {
                    this.modelOrder.quoteOverallSealerUnit = dataList.quoteOverallSealerUnit;
                    this.modelOrder.total_premium_sealing = (dataList.quoteOverallSealerUnit.totalDefenderPrice + dataList.quoteOverallSealerUnit.totalGoldPrice);
                    resolve(true);
                } else {
                    reject(false);
                }
            }, () => {
                reject(false);
            });
        });
    }

    onProductRowDrop(event: DndDropEvent, targetRow: any) {
        this.draggedProductIndex = null;
        const draggedProduct = event.data;
        const droppedOnProduct = targetRow;

        const draggedProductId = draggedProduct?.parent_id ? draggedProduct?.parent_id : draggedProduct?.id;
        const droppedOnProductId = droppedOnProduct?.parent_id ? droppedOnProduct?.parent_id : droppedOnProduct?.id;

        let quoteProducts = this.modelOrder.quote_product.filter((product) => !product.parent_id);
        const draggedIndex = quoteProducts.findIndex((product) => product.id === draggedProductId);
        const droppedIndex = quoteProducts.findIndex((product) => product.id === droppedOnProductId);

        if (draggedIndex !== -1 && droppedIndex !== -1 && draggedIndex !== droppedIndex) {
            // Move the dragged product to the new position in the array
            const [draggedProduct] = quoteProducts.splice(draggedIndex, 1);
            quoteProducts.splice(droppedIndex, 0, draggedProduct);

            // Recalculate all order_index values sequentially starting from 1
            // This ensures no gaps and prevents negative values
            quoteProducts.forEach((product, index) => {
                product.order_index = index + 1; // 1-based indexing
            });

            // Also update order_index for child products (products with parent_id)
            this.modelOrder.quote_product.forEach((product) => {
                if (product.parent_id) {
                    const parent = quoteProducts.find(p => p.id === product.parent_id);
                    if (parent) {
                        product.order_index = parent.order_index;
                    }
                }
            });

            // Preserve toggle states during drag and drop instead of resetting them
            // Note: Toggle states are preserved automatically since we're not modifying them
            // Use the sophisticated sorting function instead of simple sort
            // this.modelOrder.quote_product = this.sortQuoteProducts([...this.modelOrder.quote_product]);
            // this.debugLogger.log('After drag-drop sort:', this.modelOrder.quote_product.map(p => ({ id: p.id, order_index: p.order_index, displayIndex: p.displayIndex })));
            this.changeDetection.detectChanges();

            const updatePromises = this.modelOrder.quote_product.map((product) => {
                return firstValueFrom(
                    this.quoteService.updateQuoteProductForCreateClone(
                        {order_index: product.order_index},
                        product.id
                    )
                );
            });

            Promise.all(updatePromises)
                .then((responses) => {
                    if (responses.every((res) => !!res)) {
                        this.alertService.success(Constants.PRODUCT_ORDER_SEQUENCE_UPDATE_SUCCESS_MESSAGE);
                        this.initializeQuillEditor();

                        // Preserve toggle states before final sorting
                        const toggleStates = this.preserveToggleStates();

                        this.modelOrder.quote_product = this.sortQuoteProducts([...this.modelOrder.quote_product]);
                        if (this.isOfflineOrder && this.modelOrder.quote_product?.length > 1) {
                            const products = this.modelOrder.quote_product;
                            const lastIndex = products.length - 1;
                            const quoteProduct = products.find((p: any) => p.quote_product_applied_calculator?.length > 0);

                            if (quoteProduct) {
                                const lastProduct = {...products[lastIndex]};
                                products[lastIndex] = {
                                    ...products[lastIndex],
                                    quote_product_applied_calculator: quoteProduct.quote_product_applied_calculator,
                                    quoteProductCalculators: quoteProduct.quoteProductCalculators,
                                };

                                quoteProduct.quote_product_applied_calculator = [];
                                quoteProduct.quoteProductCalculators = lastProduct.quoteProductCalculators;
                            }
                        }

                        // Restore toggle states after final sorting
                        this.restoreToggleStates(toggleStates);

                        this.changeDetection.detectChanges();
                    }
                })
                .catch((err) => {
                    this.alertService.error('Failed to update product order sequence.');
                });

            // quoteProducts.forEach((product, index) => {
            //   this.quoteService.updateQuoteProduct({ order_index: product.order_index }, product.id).subscribe((response) => {
            //     if (response) {
            //       if (index === this.modelOrder.quote_product.length - 1) {
            //         this.alertService.success(Constants.PRODUCT_ORDER_SEQUENCE_UPDATE_SUCCESS_MESSAGE);
            //         this.initializeQuillEditor();
            //         // Ensure sorting is maintained after API updates
            //         this.modelOrder.quote_product = this.sortQuoteProducts([...this.modelOrder.quote_product]);
            //         this.changeDetection.detectChanges();
            //       }
            //     }
            //   });
            // });
        } else {
            this.draggedProductIndex = null;
        }
    }

    onProductRowDragStart(productRow: any) {
        this.draggedProductIndex = productRow.order_index;
    }

    onProductRowDragEnd() {
        this.draggedProductIndex = null;
        this.changeDetection.detectChanges();
    }

    onProductRowDragOver(event: any, targetRow: any) {
        event.preventDefault();
        if (this.hoveredProductIndex !== targetRow.order_index) {
            this.hoveredProductIndex = targetRow.order_index;
            this.changeDetection.detectChanges();
        }
    }

    hasSelectedAdhesiveCalculator(row: any): boolean {
        return !!row?.quoteProductCalculators?.some(
            c => c.type === this.constants.CONSUMABLE_CALCULATOR_TYPE_ADHESIVE && c.is_selected
        );
    }

    hasSelectedPremiumSealerCalculator(row: any): boolean {
        return !!row?.quoteProductCalculators?.some(
            c =>
                [this.constants.CONSUMABLE_CALCULATOR_TYPE_DEFENDER, this.constants.CONSUMABLE_CALCULATOR_TYPE_GOLD].includes(c.type) &&
                c.is_selected
        );
    }

    canEditCalculator(modelOrder: any, isQuoteAccepted: boolean, isDisabledQuoteDetail: boolean): boolean {
        return (modelOrder?.is_archive !== this.constants.IS_ARCHIVE_TRUE ||
                modelOrder?.status?.short_name !== this.constants.QUOTE_CANCELLED_SHORT) &&
            ((modelOrder?.status?.short_name !== this.constants.QUOTE_DEPOSIT_PAYMENT_DUE_SHORT &&
                    modelOrder?.status?.short_name !== this.constants.QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT) ||
                modelOrder?.is_archive === this.constants.IS_ARCHIVE_TRUE ||
                modelOrder?.status?.short_name === this.constants.QUOTE_EXPIRED_SHORT ||
                isDisabledQuoteDetail);
    }

    updateStockRequiredDate(id, quoteProduct: any, isCarrierPopup?: boolean, scheduleDeliveryId?: any, status?: any) {
        // SQ (offline share) quotes render in preview mode (isPreview), but must still be able to add/set the
        // SRD on each split-delivery segment (D1, D2, ...). Same SQ check as the other SQ changes
        // (quote_number SHARE_QUOTE prefix). Only relax the preview guard for an actual split segment
        // (is_split_delivery + a scheduleDeliveryId); non-SQ quotes keep the existing behaviour.
        const isSqQuote = typeof this.modelOrder?.quote_number === 'string' && this.modelOrder.quote_number.startsWith(Constants.SHARE_QUOTE);
        const isSqSplitSegment = isSqQuote && this.modelOrder?.is_split_delivery && scheduleDeliveryId != null;
        if ((this.isPreview && !isSqSplitSegment) || [Constants.ORDER_DELIVERY_CLIENT_ORGANIZED_SHORT, Constants.ORDER_DELIVERY_OUT_TO_TENDER_SHORT, Constants.ORDER_DELIVERY_DISPATCHED_SHORT, Constants.ORDER_DELIVERY_CONFIRMED_SHORT].includes(status?.short_name)) {
            return;
        }
        if (this.isOrderCancel) {
            this.alertService.error(Constants.UNABLE_TO_CHANGE_DATE);
            return;
        }
        if (this.modelOrder?.is_expired === Constants.IS_TRUE) {
            this.alertService.error(Constants.UNABLE_QUOTE_STATUS_CHANGE_WITH_EXPIRED);
            return;
        }
        if (this.modelOrder?.is_archive === Constants.IS_TRUE) {
            this.alertService.error(Constants.UNABLE_ORDER_DETAIL_CHANGE);
            return;
        }
        if (this.modelOrder?.status?.short_name === Constants.ORDER_DELIVERD_SHORT || this.modelOrder?.status?.short_name === Constants.ORDER_FOLLOW_UP_SHORT || status?.short_name === Constants.ORDER_DELIVERD_SHORT) {
            this.alertService.error(Constants.UNABLE_DELIVERED_QUOTE_PRODUCT_CHANGE);
            return;
        }
        if (this.modelOrder?.status?.short_name === Constants.ORDER_COMPLETED_SHORT) {
            this.alertService.error(Constants.UNABLE_COMPLETED_QUOTE_PRODUCT_CHANGE);
            return;
        }

        const instance = this.modalService1.open(UpdateStockRequiredDateModalComponent,
            {
                centered: false,
                windowClass: 'donationModals quotes-model quote-order-export-pdf-model',
                backdrop: 'static',
            }
        );

        const modelOrderObject = {
            id: this.modelOrder.id,
            stock_required_date: quoteProduct?.stock_required_date,
            type: this.modelOrder.type,
            quote_product_id: id,
            schedule_delivery_id: scheduleDeliveryId ?? null,
            quote_product: this.modelOrder.quote_product,
            is_consumable_order: this.modelOrder?.is_consumable_order,
            isSplitDelivery: this.modelOrder?.is_split_delivery,
            leadTime: this.modelOrder?.leadTime
        }
        instance.componentInstance.modelOrder = modelOrderObject;
        instance.componentInstance.isFromQuoteProduct = true;
        instance.closed.subscribe(async (result) => {
            if (result) {
                // ⚠️ FIX: Use ONLY triggerQuote() signal instead of both getOrderEvent.emit() and triggerQuote()
                // The getOrderEvent.emit() was causing double refresh when combined with triggerQuote()
                // triggerQuote() will trigger the effect() in parent which calls handleGetOrderDetail()
                if (quoteProduct) {
                    quoteProduct.stock_required_date = result;
                }
                this.subscribersService.trigger();
                this.subscribersService.triggerQuote();

                this.webSocketService.emit('quote_updated', {
                    quoteId: this.modelOrder.id,
                    exportId: this.modelOrder.export_id
                });
                if (isCarrierPopup)
                    this.openCarrierPopup(quoteProduct);
            }
        });
    }

    openChangeStatusPopup(status, row) {
        // this.debugLogger.log(this.modelOrder?.is_split_delivery);
        // this.debugLogger.log(row?.quote_schedule_delivery_product?.quote_schedule_delivery_id);
        // this.debugLogger.log(this.modelOrder?.quote_product);
        if (!this.shouldUpdateStatus(row)) {
            return false;
        }
        if (status.short_name === Constants.ORDER_PACKING_SHORT && status.is_complete && [Constants.ORDER_DELIVERY_UNCONFIRMED, Constants.ORDER_DELIVERY_OUT_TO_TENDER_SHORT, Constants.ORDER_DELIVERY_CLIENT_ORGANIZED_SHORT].includes(row?.status_quote_product?.short_name)) {
            this.openConfirmationPopUp(status, row);
            return;
        }
        if (status.id == row.status_id || this.modelOrder?.is_archive || this.modelOrder?.is_expired || this.modelOrder?.status?.short_name === Constants.ORDER_DELIVERD_SHORT || this.modelOrder?.status?.short_name === Constants.ORDER_FOLLOW_UP_SHORT || this.modelOrder?.status?.short_name === Constants.ORDER_COMPLETED_SHORT) return;
        const getStatusByName = (name: string) => Constants.GOODS_DISPATCHED_ORDER_ARRAY.find((i: any) => i.name === name);

        if (status.name == Constants.GOODS_DISPATCHED_PENDING && row.status_quote_product.short_name == Constants.ORDER_DELIVERY_UNCONFIRMED) {
            if (!this.isStatusChangeToOTT) {
                this.alertService.error(Constants.UNABLE_TO_CHANGE_STATUS_OTT);
                return;
            }
            if (!row.quote_schedule_delivery_product?.quote_schedule_delivery) return;
            if (!row?.quote_schedule_delivery_product?.stock_required_date) {
                this.updateStockRequiredDate(row.id, row, true, row.quote_schedule_delivery_product.quote_schedule_delivery.id);
                return false;
            }
            if (!row.quote_schedule_delivery_product.quote_schedule_delivery.join_quote_site_contact_schedule_delivery?.length) {
                this.updateSiteContactForm(row.quote_schedule_delivery_product.quote_schedule_delivery.id, row, row.quote_schedule_delivery_product.quote_schedule_delivery.quote_address?.is_warehouse_collection ? false : true, true);
                return;
            }
            if (!row.quote_schedule_delivery_product.quote_schedule_delivery.carrier_id) {
                this.openCarrierPopup(row);
            } else {
                const nextStatus = getStatusByName(Constants.GOODS_DISPATCHED_PENDING);
                if (nextStatus) {
                    this.openConfirmationPopUp(nextStatus, row);
                    return false;
                }
            }
        }

        if (status.name == Constants.GOODS_DISPATCHED_DECLINED) {
            if (this.modelOrder.is_split_production) {
                const hasInvalidStatus = this.modelOrder.quote_product.some(
                    (qp: any) =>
                        qp.quote_schedule_delivery_product?.quote_schedule_delivery_id ==
                        row.quote_schedule_delivery_product.quote_schedule_delivery_id &&
                        !qp.quote_product_status_history?.some((sh: any) => sh.status_id === Constants.ORDER_STATUS_ARRAY_ID.AAW)
                );
                if (hasInvalidStatus) {
                    return;
                }
            }
            const nextStatus = getStatusByName(Constants.GOODS_DISPATCHED_DECLINED);
            if (nextStatus) {
                this.openConfirmationPopUp(nextStatus, row);
                return false;
            }
        }

        if (status.name == Constants.GOODS_DISPATCHED_CONFIRMED && [Constants.ORDER_DELIVERY_CONFIRMED_SHORT, Constants.ORDER_DELIVERY_CLIENT_ORGANIZED_SHORT].includes(row.status_quote_product.short_name)) {
            const nextStatus = getStatusByName(Constants.GOODS_DISPATCHED_CONFIRMED);
            if (nextStatus) {
                this.openConfirmationPopUp(nextStatus, row);
                return false;
            }
        }

        if (status.name === Constants.GOODS_DISPATCHED_CLIENT_ORGANIZED && row.quote_schedule_delivery_product.quote_schedule_delivery.quote_address?.is_warehouse_collection && row.status_quote_product.short_name == Constants.ORDER_DELIVERY_UNCONFIRMED) {
            const nextStatus = getStatusByName(Constants.GOODS_DISPATCHED_CLIENT_ORGANIZED);
            if (nextStatus) {
                this.openConfirmationPopUp(nextStatus, row);
                return false;
            }
        }

        if (status.name === Constants.GOODS_DISPATCHED_DELIVERD && row.status_quote_product.short_name == Constants.ORDER_DELIVERY_DISPATCHED_SHORT) {
            const nextStatus = getStatusByName(Constants.GOODS_DISPATCHED_DELIVERD);
            if (nextStatus) {
                this.openConfirmationPopUp(nextStatus, row);
                return false;
            }
        }

    }

    shouldUpdateStatus(row: any): boolean {
        if (!row || !this.modelOrder?.is_split_delivery) {
            return false;
        }

        const scheduleId = row?.quote_schedule_delivery_product?.quote_schedule_delivery_id;
        if (!scheduleId || !this.modelOrder?.quote_product?.length) {
            return false;
        }

        // ✅ Directly filter products for this scheduleId instead of grouping all
        const scheduleDeliveryProducts = this.modelOrder.quote_product.filter(
            p => p?.quote_schedule_delivery_product?.quote_schedule_delivery_id === scheduleId
        );

        if (!scheduleDeliveryProducts.length) {
            return false;
        }

        // ✅ Check if *all* products in this schedule have the required status
        if (this.modelOrder.is_split_production) {
            return scheduleDeliveryProducts.every(product =>
                product?.quote_product_status_history?.some(
                    history => history.status_id === Constants.ORDER_AVAILABLE_AT_WAREHOUSE_ID
                )
            );
        } else {
            return this.modelOrder.quote_order_status_history.some(
                history => history.quote_order_status_id === Constants.ORDER_AVAILABLE_AT_WAREHOUSE_ID
            );
        }
    }

    updateSiteContactForm(scheduleDeliveryId: any, row: any, isCarrierPopup?: boolean, isDisplayStockRequiredPopup?: boolean) {
        if (this.modelOrder?.is_archive) {
            this.alertService.error(Constants.UNABLE_ORDER_DETAIL_CHANGE);
            return false;
        }

        const instance = this.modalService1.open(
            UpdateSiteContactDetailModalComponent,
            {
                centered: false,
                windowClass: 'donationModals quotes-model quote-order-export-pdf-model',
                backdrop: 'static',
            }
        );
        const modelOrder = {
            id: this.modelOrder.id,
            quoteOwner: this.modelOrder.quoteOwner,
            is_draft: this.modelOrder.is_draft,
            defaultQuoteSiteContactId: this.modelOrder.quote_site_contact?.[0]?.id,
            quote_schedule_delivery_id: scheduleDeliveryId
        }

        instance.componentInstance.modelOrder = modelOrder;
        instance.componentInstance.isScheduleDeliveryUpdate = true;
        instance.closed.subscribe((result) => {
            if (result) {
                // this.getOrderDetail(false);
                this.getOrderEvent.emit(false);
                this.subscribersService.trigger();
                if (isDisplayStockRequiredPopup) {
                    this.handleStockRequiredPopup(row, isCarrierPopup);
                }
            }
        });
    }

    handleStockRequiredPopup(row, isCarrierPopup?: boolean) {
        if (!row?.quote_schedule_delivery_product?.stock_required_date) {
            this.updateStockRequiredDate(row.id, row, true, row.quote_schedule_delivery_product.quote_schedule_delivery.id);
            return false;
        } else if (isCarrierPopup) {
            this.openCarrierPopup(row);
        }
    }

    openCarrierPopup(row) {
        if (
            ((!row.quote_schedule_delivery_product?.quote_schedule_delivery?.carrier_id) &&
                row.quote_schedule_delivery_product?.quote_schedule_delivery?.is_used_own_transport) ||
            (row.quote_schedule_delivery_product.quote_schedule_delivery.quote_address?.is_warehouse_collection)
        ) {
            return;
        }
        if (this.modelOrder?.is_archive) {
            this.alertService.error(Constants.UNABLE_ORDER_DETAIL_CHANGE);
            return false;
        }

        const instance = this.modalService1.open(ChooseCarrierModalComponent, {
            windowClass: 'required-date-modal',
            backdrop: 'static',
        });

        let modelOrder = {
            id: row.id,
            carrier_id: row.quote_schedule_delivery_product?.quote_schedule_delivery?.carrier_id,
            is_used_own_transport: row.quote_schedule_delivery_product?.quote_schedule_delivery?.is_used_own_transport,
            quote_schedule_delivery_id: row.quote_schedule_delivery_product?.quote_schedule_delivery?.id,
            delivery_charge: row.quote_schedule_delivery_product?.quote_schedule_delivery?.delivery_charge,
            crates: row.quote_schedule_delivery_product?.quote_schedule_delivery?.crates,
        }
        instance.componentInstance.quoteOrderModel = modelOrder;
        instance.closed.subscribe(async (data) => {
            if (data) {
                if (
                    data.is_used_own_transport !== undefined &&
                    !data.is_used_own_transport
                ) {
                    const SendMail = await this.carrierMailSend(modelOrder?.id);
                }
                await this.updateOrderSummary(this.modelOrder.id);
                this.getOrderEvent.emit(false);
                this.subscribersService.trigger();
                // await this.getOrderDetail(false);
                // this.getNoteDetail(this.modelOrder.quote_status_id);
            }
        });
    }

    openConfirmationPopUp(quoteAndOrderStatusValue: any, row: any, is_change_previous_status: any = false) {
        const instance = this.modalService1.open(
            StatusChangeConfirmationComponent,
            {
                centered: false,
                windowClass: 'custom-status-change-confirmation-model',
                backdrop: 'static',
            }
        );
        instance.componentInstance.title = 'Confirm Status Change';
        instance.componentInstance.status = quoteAndOrderStatusValue.name;
        if (quoteAndOrderStatusValue.name == Constants.GOODS_DISPATCHED_CONFIRMED) {
            instance.componentInstance.message = Constants.CARRIER_CONFIRM_MESSAGE_CHANGE_STATUS + ' despatched?';
        } else {
            instance.componentInstance.message = Constants.ORDER_CONFIRM_MESSAGE_CHANGE_STATUS + quoteAndOrderStatusValue.name + '?';
        }

        instance.closed.subscribe((result) => {
            if (!result) return;
            const quoteStatusRequestData = {
                id: row.id,
                status: quoteAndOrderStatusValue.short_name || quoteAndOrderStatusValue.status?.[0],
                quote_schedule_delivery_id: row.quote_schedule_delivery_product?.quote_schedule_delivery_id
            };

            this.statusService.changeQuoteProductStatus(quoteStatusRequestData).subscribe({
                next: () => {
                    this.alertService.success(Constants.ORDER_STATUS_CHANGE_SUCCESS);
                    this.isLoading = false;
                    this.getOrderEvent.emit(false);
                    this.subscribersService.trigger();
                },
                error: (error: any) => {
                    this.isLoading = false;
                }
            });
        })
    }

    carrierMailSend(quoteProductId?) {
        return new Promise(async (resolve, reject) => {
            const status = Constants.ORDER_DELIVERY_OUT_TO_TENDER_SHORT;
            const KeyName = Constants.EMAIL_TEMPLATE_KEY_NAME.filter(
                (constant: any) =>
                    constant.status?.indexOf(status) > -1
                // &&
                // constant.TYPE == this.modelOrder.type
            );

            if (KeyName.length > 0) {
                const dataOfConstant = KeyName[0];
                const instance = this.modalService1.open(
                    MailTemplateEditOnStatusChangeComponent,
                    {
                        windowClass: 'mail-body-edit',
                        centered: true,
                    }
                );
                instance.componentInstance.keyName = dataOfConstant.KEY_NAME;
                instance.componentInstance.titleName =
                    Constants.EMAIL_TEMPLATE_TITLE.CARRIER;
                instance.componentInstance.quoteId = this.modelOrder.id;
                instance.closed.subscribe((result) => {
                    if (result) {
                        // this.isLoading = true;
                        this.isLoadingEvent.emit(true);
                        let json = {};
                        var recipientEmails: any = [];
                        if (result.data.emails.length > 0) {
                            result.data.emails.forEach((email: any) => {
                                if (email.email) {
                                    recipientEmails.push(email.email);
                                }
                            });

                            json = {
                                quote_order_id: this.modelOrder?.id,
                                quote_order_status: status,
                                email_template_title: result.data.title,
                                email_template_body: result.data.body,
                                recipient_emails: recipientEmails,
                                is_send_copy_to_sales_representative:
                                result.data.is_send_copy_to_sales_representative,
                                quote_product_id: quoteProductId,
                            };
                        } else {
                            json = {
                                quote_order_id: this.modelOrder?.id,
                                quote_order_status: status,
                                email_template_title: result.data.title,
                                email_template_body: result.data.body,
                                is_send_copy_to_sales_representative:
                                result.data.is_send_copy_to_sales_representative,
                                quote_product_id: quoteProductId,
                            };
                        }

                        this.orderService.sendMail(json).subscribe(
                            (data: any) => {
                                // this.isLoading = false;
                                this.isLoadingEvent.emit(false);
                                this.alertService.success(Constants.SUCCESS_MESSAGE_ON_COLLECTION_AND_DELIVERY_REQUEST_MAIL_SENT);
                                resolve(true);
                            },
                            (error) => {
                                // this.isLoading = false;
                                this.isLoadingEvent.emit(false);
                                this.alertService.success(Constants.ERROR_MESSAGE_ON_COLLECTION_AND_DELIVERY_REQUEST_MAIL_SENT);
                                resolve(true);
                            }
                        );
                    } else {
                        resolve(true);
                    }
                });
            } else {
                resolve(true);
            }
        });
    }

    changeJobStatus(confirmMessage: string, successMessage: string, status: string, id, quoteScheduleDeliveryId) {
        if (this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES) {
            this.alertService.error(Constants.UNABLE_ORDER_DETAIL_CHANGE);
            return;
        }
        if (this.isOrderCancel) {
            return;
        }

        this.modalRef = this.modalService.show(ConfirmModalComponent);
        this.modalRef.content.message = confirmMessage;
        this.modalRef.content.title = 'Confirm';
        this.modalRef.setClass('delete-favourite-modal');

        this.modalRef.content.onClose.subscribe((result: boolean) => {
            if (!result) return;

            this.isLoadingEvent.emit(true);
            const requestData = {
                id: id,
                status: status,
                quote_schedule_delivery_id: quoteScheduleDeliveryId
            };

            this.statusService.changeQuoteProductStatus(requestData).subscribe({
                next: () => {
                    this.alertService.success(successMessage);
                    this.getOrderEvent.emit(false);
                    this.subscribersService.trigger();
                    this.isLoadingEvent.emit(false);
                    // this.getOrderDetail(false);
                },
                error: () => {
                    this.isLoadingEvent.emit(false);
                }
            });
        });
    }

    acceptJob(id, quoteScheduleDeliveryId) {
        this.changeJobStatus(Constants.CONFIRMATION_MESSAGE_FOR_ACCEPT_JOB, Constants.SUCCESS_MESSAGE_OF_ACCEPT_JOB, Constants.ORDER_DELIVERY_CONFIRMED_SHORT, id, quoteScheduleDeliveryId);
    }

    declineJob(id, quoteScheduleDeliveryId) {
        this.changeJobStatus(Constants.CONFIRMATION_MESSAGE_FOR_DECLINE_JOB, Constants.SUCCESS_MESSAGE_OF_DECLINE_JOB, Constants.ORDER_DELIVERY_UNCONFIRMED, id, quoteScheduleDeliveryId);
    }

    getSRDTooltip(product) {
        if (product?.quote_schedule_delivery_product?.stock_required_date == null) {
            product.isDisplayPulsingEffect = true;
            return 'No Stock Required Date (SRD) Added';
        }
        const isDespatchedStatusExist = this.getGoodDispatchSeriesStatus.find(
            (item) => item == product?.status_quote_product?.short_name
        );
        if (isDespatchedStatusExist) {
            return (
                'Stock Required Date (SRD):<br>' +
                this.formatDate(product?.quote_schedule_delivery_product?.stock_required_date)
            );
        } else {
            if (product?.quote_schedule_delivery_product?.stock_required_date) {
                let stockRequiredDate = this.datePipe.transform(
                    product.quote_schedule_delivery_product.stock_required_date,
                    'dd/MM/yyyy'
                );
                let currentTime = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
                let stockRequiredDateTime = new Date(
                    product?.quote_schedule_delivery_product?.stock_required_date
                ).getTime();

                if (stockRequiredDateTime <= new Date(currentTime).getTime()) {
                    product.isDisplayPulsingEffect = true;
                    return 'SRD Expired:<br>' + stockRequiredDate;
                }
            }
            if (
                (product?.container?.anticipated_warehouse_arrival_date || product?.container?.[0]?.anticipated_warehouse_arrival_date) && product?.quote_schedule_delivery_product?.stock_required_date
            ) {
                let stockRequiredDateforCnflict = this.datePipe.transform(
                    product.quote_schedule_delivery_product.stock_required_date,
                    'dd/MM/yyyy'
                );
                let stockRequiredDate = new Date(
                    product.quote_schedule_delivery_product.stock_required_date
                ).getTime();
                let warehouseArrivalDate = new Date(
                    product?.container?.anticipated_warehouse_arrival_date || product?.container?.[0]?.anticipated_warehouse_arrival_date
                ).getTime();

                if (warehouseArrivalDate > stockRequiredDate) {
                    product.isDisplayPulsingEffect = true;
                    return 'SRD Conflict:<br>' + stockRequiredDateforCnflict;
                }
            }
        }
        return (
            'Stock Required Date (SRD):<br>' +
            this.formatDate(product.quote_schedule_delivery_product.stock_required_date)
        );
    }

    formatDate(date: string) {
        return date != null ? moment(date).format('DD/MM/YYYY') : 'N/A';
    }

    getDeliveryCodeSuffix(deliveryCode: string): string {
        if (!deliveryCode) {
            return '';
        }
        const parts = deliveryCode.split('-');
        return parts.length > 0 ? parts[parts.length - 1] : deliveryCode;
    }

    getSRDTooltip1(productsRow) {
        if (!productsRow?.activity) return null;
        const result = productsRow.activity.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()).find(item => item.activity_type_id == 91);
        if (result?.frontend_user?.id) {
            return {
                user_name: `${result.frontend_user.first_name} ${result.frontend_user.last_name}`,
                change_at: this.formatDate(result.created_at),
                user_profile: result.frontend_user.profile_picture,
                is_changed_from_frontend: true
            }
        }
        if (result?.backend_user?.id) {
            return {
                user_name: `${result.backend_user.first_name} ${result.backend_user.last_name}`,
                change_at: this.formatDate(result.created_at),
                user_profile: result.backend_user.profile_picture
            }
        }
        return null;
    }

    taskHasCategory(tasks: any[]): boolean {
        return tasks.some((task) => task.task_category != null);
    }

    isTaskDisplay(task: any): boolean {
        if (task.status === Constants.TASK_PENDING) {
            return true;
        }

        return false;
    }

    handleDropActionCompleted(event: any) {
        this.debugLogger.log('✅ Drop action completed in product-detail-section:', event);
        // This used to do nothing, on the grounds that stock-allocation-content called triggerQuote()
        // itself. That call was removed in favour of the order_created socket round trip, which does
        // not reach this table — so after a split the new line only appeared on a manual page reload.
        // Refresh through the same emitter every other mutation in this component uses.
        this.getOrderEvent.emit(false);
    }


    /**
     * Calculate modulo for decimal numbers with proper precision
     * Fixes floating-point precision issues (e.g., 9.9 % 0.9 should be 0, not 1.11e-15)
     * @param dividend - The number to be divided (quantity)
     * @param divisor - The number to divide by (MOI)
     * @returns The remainder rounded to 10 decimal places
     */
    calculateModulo(dividend: number, divisor: number): number {
        if (!dividend || !divisor || divisor === 0) {
            return 0;
        }

        // Compliant when the quantity is (within FP tolerance) a whole multiple
        // of moi. Comparing the ratio to its nearest integer avoids the `%`
        // floating-point error, e.g. 28.9809 % 0.2477 returns ~0.2477 not 0.
        const ratio = dividend / divisor;
        const rounded = Math.round(ratio);
        return Math.abs(ratio - rounded) < 1e-9 ? 0 : dividend % divisor;
    }

    shouldDisplayAdhesiveOrSealerCalculator(row: any, calculatorTypes: string[]): boolean {
        const calculators = row?.quoteProductCalculators;
        if (!calculators?.length || !calculatorTypes?.length) return false;

        // Use a Set for O(1) lookup performance
        const typeSet = new Set(calculatorTypes);

        for (let i = 0; i < calculators.length; i++) {
            const c = calculators[i];
            if (typeSet.has(c.type) && c.is_selected === true) {
                return true; // ✅ immediate return, avoids unnecessary loops
            }
        }

        return false;
    }

    protected readonly Constants = Constants;

    getSizingDimensions(product: any): string {
        if (product) {
            const sizingDimensions: string[] = [];

            // Helper to remove 'mm' (case insensitive) and spaces from any value
            const cleanValue = (val: string) => val.replace(/mm/gi, '').trim();

            // 1. Clean Length
            if (product.length && product.length.trim() !== '') {
                sizingDimensions.push(cleanValue(product.length));
            }

            // 2. Clean Width
            if (product.width && product.width.trim() !== '') {
                sizingDimensions.push(cleanValue(product.width));
            }

            // 3. Clean Thickness
            if (product.thickness && product.thickness.trim() !== '') {
                sizingDimensions.push(cleanValue(product.thickness));
            }

            const result = sizingDimensions.join(' x ');

            if (!result) {
                return '';
            }

            // Get the last item added (e.g., "30" or "French Pattern")
            const lastItem = sizingDimensions[sizingDimensions.length - 1];

            // Check if the last item contains any digit (0-9)
            // "30" -> true
            // "30.5" -> true
            // "XL French Pattern" -> false
            const hasNumber = /\d/.test(lastItem);

            // If the last part has a number, add 'mm', otherwise return just the string
            return hasNumber ? result + ' mm' : result;
        }
        return '';
    }

    isOrderDeliveryStage() {
        const deliveryStatuses = [Constants.ORDER_DELIVERY_UNCONFIRMED, Constants.ORDER_DELIVERY_OUT_TO_TENDER_SHORT, Constants.ORDER_DELIVERY_CONFIRMED_SHORT, Constants.ORDER_DELIVERY_CLIENT_ORGANIZED_SHORT, Constants.ORDER_DELIVERY_DISPATCHED_SHORT, Constants.ORDER_DELIVERD_SHORT, Constants.ORDER_FOLLOW_UP_SHORT, Constants.ORDER_COMPLETED_SHORT];

        if (deliveryStatuses.includes(this.modelOrder?.status?.short_name)) return true;
        else return false;
    }

    isOrderProductDeliveryStage(productsRow) {
        const deliveryStatuses = [Constants.ORDER_DELIVERY_UNCONFIRMED, Constants.ORDER_DELIVERY_OUT_TO_TENDER_SHORT, Constants.ORDER_DELIVERY_CONFIRMED_SHORT, Constants.ORDER_DELIVERY_CLIENT_ORGANIZED_SHORT, Constants.ORDER_DELIVERY_DISPATCHED_SHORT, Constants.ORDER_DELIVERD_SHORT, Constants.ORDER_FOLLOW_UP_SHORT, Constants.ORDER_COMPLETED_SHORT];

        if (deliveryStatuses.includes(this.modelOrder?.status?.short_name) || (this.modelOrder.is_split_delivery && deliveryStatuses.includes(productsRow?.status_quote_product?.short_name))) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Check if price update warning should be displayed for a product
     * Warning shows when: (quote is expired OR archived) AND product has unleashed price update
     */
    shouldShowPriceUpdateWarning(product: any): boolean {
        // Only show in preview & quote detail views
        if (!this.isPreview && !this.isQuoteDetail) {
            return false;
        }

        // Check if quote is expired or archived
        const isQuoteExpired = this.modelOrder?.is_expired === Constants.QUOTE_IS_EXPIRED_YES;
        const isQuoteArchived = this.modelOrder?.is_archive === Constants.IS_ARCHIVE_YES;

        // Check if product has unleashed price update
        const hasUnleashedPriceUpdate = product?.is_unleashed_price_updated;

        // Show warning if (expired OR archived) AND has unleashed price update
        const shouldShow = (isQuoteExpired || isQuoteArchived) && hasUnleashedPriceUpdate;

        return shouldShow;
    }

    /**
     * Check if price update warning has been dismissed for a product
     */
    isPriceWarningDismissed(productId: number): boolean {
        return this.dismissedPriceWarnings.has(productId);
    }

    /**
     * Dismiss price update warning for a product
     */
    dismissPriceWarning(productId: number): void {
        this.dismissedPriceWarnings.add(productId);
        this.changeDetection.detectChanges();
    }
}
